const neighborhoods = {
  //  ARGENTINA
  bariloche: {
    Aeropuerto: {
      adr_address: '<span class="street-address">RP80 S/N</span>, <span class="locality">San Carlos de Bariloche</span>, <span class="region">Río Negro</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'RP80 S/N, San Carlos de Bariloche, Río Negro, Argentina',
      geometry: {
        location: {
          lat: -41.1459655,
          lng: -71.1615774,
        },
      },
      place_id: 'ChIJV3SMGHGIGpYRmWIRezUQ43w',
    },
    Belgrano: {
      adr_address: 'Belgrano, <span class="locality">San Carlos de Bariloche</span>, <span class="region">Río Negro</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Belgrano, San Carlos de Bariloche, Río Negro, Argentina',
      geometry: {
        location: {
          lat: -41.1354006,
          lng: -71.3218165,
        },
      },
      place_id: 'ChIJBQ56gA97GpYRtw98K58zQuw',
    },
    'Centro Cívico': {
      adr_address: 'Centro Cívico, <span class="postal-code">R8400</span> <span class="locality">San Carlos de Bariloche</span>, <span class="region">Río Negro</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Centro Cívico, San Carlos de Bariloche, Río Negro, Argentina',
      geometry: {
        location: {
          lat: -41.133496,
          lng: -71.3102123,
        },
      },
      place_id: 'ChIJ4Qi323J7GpYRlKog-JJ-G9k',
    },
    'Jardín Botánico': {
      adr_address: 'Jardín Botanico, <span class="locality">San Carlos de Bariloche</span>, <span class="region">Río Negro</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Jardín Botanico, San Carlos de Bariloche, Río Negro, Argentina',
      geometry: {
        location: {
          lat: -41.1435111,
          lng: -71.3177793,
        },
      },
      place_id: 'ChIJp3fREhZ7GpYRQV5CuL8LnFE',
    },
    Melipal: {
      adr_address: 'Melipal, <span class="locality">San Carlos de Bariloche</span>, <span class="region">Río Negro</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Melipal, San Carlos de Bariloche, Río Negro, Argentina',
      geometry: {
        location: {
          lat: -41.1317974,
          lng: -71.3556698,
        },
      },
      place_id: 'ChIJy9ABEV96GpYRHFg85VFE3NM',
    },
    'Playa Centenario': {
      adr_address: 'Playa Centenario - Bariloche, <span class="region">Río Negro</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Playa Centenario - Bariloche, Río Negro, Argentina',
      geometry: {
        location: {
          lat: -41.1322734,
          lng: -71.2924707,
        },
      },
      place_id: 'ChIJr8Uosnx7GpYRmI5cnTJppBU',
    },
    Terminal: {
      adr_address: '<span class="street-address">12 de Octubre 2400</span>, <span class="locality">San Carlos de Bariloche</span>, <span class="region">Río Negro</span>, <span class="country-name">Argentina</span>',
      formatted_address: '12 de Octubre 2400, San Carlos de Bariloche, Río Negro, Argentina',
      geometry: {
        location: {
          lat: -41.1304334,
          lng: -71.2719654,
        },
      },
      place_id: 'ChIJ60sNupF8GpYRr-ttrn8fwJ0',
    },
    '10 de Diciembre': {
      adr_address: '10 de Diciembre, <span class="locality">San Carlos de Bariloche</span>, <span class="region">Río Negro</span>, <span class="country-name">Argentina</span>',
      formatted_address: '10 de Diciembre, San Carlos de Bariloche, Río Negro, Argentina',
      geometry: {
        location: {
          lat: -41.140482,
          lng: -71.3017201,
        },
      },
      place_id: 'ChIJ1xSuH2l7GpYR_g84AKrrlR4',
    },
  },
  'buenos-aires': {
    Almagro: {
      adr_address: 'Almagro, <span class="locality">CABA</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Almagro, CABA, Argentina',
      geometry: {
        location: {
          lat: -34.6114447,
          lng: -58.4209936,
        },
      },
      place_id: 'ChIJ_xfaQV7KvJURP_KYJq2fzus',
    },
    Balvanera: {
      adr_address: 'Balvanera, <span class="locality">CABA</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Balvanera, CABA, Argentina',
      geometry: {
        location: {
          lat: -34.6101223,
          lng: -58.40594059999999,
        },
      },
      place_id: 'ChIJUaOV2u_KvJURIbHgKZTw24g',
    },
    Belgrano: {
      adr_address: 'Belgrano, <span class="locality">CABA</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Belgrano, CABA, Argentina',
      geometry: {
        location: {
          lat: -34.5620844,
          lng: -58.4566864,
        },
      },
      place_id: 'ChIJHWEmhdK1vJURaQDH3amFtbw',
    },
    Caballito: {
      adr_address: 'Caballito, <span class="locality">CABA</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Caballito, CABA, Argentina',
      geometry: {
        location: {
          lat: -34.6159245,
          lng: -58.4406027,
        },
      },
      place_id: 'ChIJLav4ETnKvJURLX3Y88KUsyc',
    },
    Colegiales: {
      adr_address: 'Colegiales, <span class="locality">CABA</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Colegiales, CABA, Argentina',
      geometry: {
        location: {
          lat: -34.5760225,
          lng: -58.4483554,
        },
      },
      place_id: 'ChIJ2xd8QN21vJURpZ8sVWPiAPc',
    },
    Constitución: {
      adr_address: 'Constitución, <span class="locality">CABA</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Constitución, CABA, Argentina',
      geometry: {
        location: {
          lat: -34.6261244,
          lng: -58.38595239999999,
        },
      },
      place_id: 'ChIJ12qUICXLvJURrYQDRo2PH1M',
    },
    'La Boca': {
      adr_address: 'La Boca, <span class="locality">CABA</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'La Boca, CABA, Argentina',
      geometry: {
        location: {
          lat: -34.6344961,
          lng: -58.36313370000001,
        },
      },
      place_id: 'ChIJpfBfv7A0o5URoJl1DYymWDg',
    },
    Montserrat: {
      adr_address: 'Monserrat, <span class="locality">CABA</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Monserrat, CABA, Argentina',
      geometry: {
        location: {
          lat: -34.6130871,
          lng: -58.38135990000001,
        },
      },
      place_id: 'ChIJVdFxwtfKvJUR9f_-uzaJ-ck',
    },
    Nuñez: {
      adr_address: 'Núñez, <span class="locality">CABA</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Núñez, CABA, Argentina',
      geometry: {
        location: {
          lat: -34.5427503,
          lng: -58.4601452,
        },
      },
      place_id: 'ChIJMy-Q9iC0vJURDbrKe9ElmDE',
    },
    Palermo: {
      adr_address: 'Palermo, <span class="locality">CABA</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Palermo, CABA, Argentina',
      geometry: {
        location: {
          lat: -34.5780655,
          lng: -58.4265317,
        },
      },
      place_id: 'ChIJM7ked5y1vJURaYzXlrUTMWs',
    },
    'Puerto Madero': {
      adr_address: 'Puerto Madero, <span class="locality">CABA</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Puerto Madero, CABA, Argentina',
      geometry: {
        location: {
          lat: -34.6177194,
          lng: -58.3620561,
        },
      },
      place_id: 'ChIJiQPXwtk0o5URj2cW455eew4',
    },
    Recoleta: {
      adr_address: 'Recoleta, <span class="locality">CABA</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Recoleta, CABA, Argentina',
      geometry: {
        location: {
          lat: -34.5873825,
          lng: -58.39727620000001,
        },
      },
      place_id: 'ChIJL_wJxpnKvJURdYqAUZOpLDk',
    },
    Retiro: {
      adr_address: 'Retiro, <span class="locality">CABA</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Retiro, CABA, Argentina',
      geometry: {
        location: {
          lat: -34.5896061,
          lng: -58.3802473,
        },
      },
      place_id: 'ChIJMdqf-7bKvJURKVmUfPNLO8Y',
    },
    Saavedra: {
      adr_address: 'Saavedra, <span class="locality">CABA</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Saavedra, CABA, Argentina',
      geometry: {
        location: {
          lat: -34.5545188,
          lng: -58.4915986,
        },
      },
      place_id: 'ChIJQVcf7Oy2vJURC3cF00QoUEI',
    },
    'San Nicolás': {
      adr_address: 'San Nicolás, <span class="locality">CABA</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'San Nicolás, CABA, Argentina',
      geometry: {
        location: {
          lat: -34.603699,
          lng: -58.381163,
        },
      },
      place_id: 'ChIJ9dxVj8_KvJURgnMzFleTc9A',
    },
    'San Telmo': {
      adr_address: 'San Telmo, <span class="locality">CABA</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'San Telmo, CABA, Argentina',
      geometry: {
        location: {
          lat: -34.6218351,
          lng: -58.3713942,
        },
      },
      place_id: 'ChIJARxeEi3LvJURq3WYlwd22aw',
    },
  },
  cordoba: {
    Aeropuerto: {
      adr_address: '<span class="street-address">E53</span>, <span class="postal-code">X5008</span> <span class="locality">Córdoba</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'E53, X5008 Córdoba, Argentina',
      geometry: {
        location: {
          lat: -31.3154774,
          lng: -64.2137656,
        },
      },
      place_id: 'ChIJdSmRTsSbMpQRD8PnyLLzWws',
    },
    Alberdi: {
      adr_address: '<span class="street-address">Av. Colón 1301</span>, <span class="postal-code">X5000</span> <span class="locality">EQA</span>, <span class="region">Córdoba</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Alberdi, Córdoba, Argentina',
      geometry: {
        location: {
          lat: -31.40853499999999,
          lng: -64.2007443,
        },
      },
      place_id: 'ChIJJ25vg4aYMpQRq4H1V5-WuYc',
    },
    Centro: {
      adr_address: 'Centro, <span class="locality">Córdoba</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Centro, Córdoba, Argentina',
      geometry: {
        location: {
          lat: -31.4164211,
          lng: -64.182709,
        },
      },
      place_id: 'ChIJRZ0_HZ2iMpQRkpeBEgSRzcs',
    },
    'Ciudad Universitaria': {
      adr_address: '<span class="street-address">Blvd. de la Reforma</span>, <span class="locality">Córdoba</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Blvd. de la Reforma, Córdoba, Argentina',
      geometry: {
        location: {
          lat: -31.4376725,
          lng: -64.1886057,
        },
      },
      place_id: 'ChIJ7-gd8I2iMpQRYWtLQ-51hkg',
    },
    'General Paz': {
      adr_address: 'Barrio Gral. Paz, <span class="locality">Córdoba</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Barrio Gral. Paz, Córdoba, Argentina',
      geometry: {
        location: {
          lat: -31.4176584,
          lng: -64.1742938,
        },
      },
      place_id: 'ChIJ1_Ak_ZiiMpQRBpxNTBI5nfg',
    },
    Güemes: {
      adr_address: '<span class="street-address">Belgrano 827</span>, <span class="postal-code">X5000JQQ</span> <span class="locality">X5000JQQ</span>, <span class="region">Córdoba</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Barrio Güemes, Córdoba, Argentina',
      geometry: {
        location: {
          lat: -31.4245728,
          lng: -64.1922141,
        },
      },
      place_id: 'ChIJlTLA1IeiMpQRXqjjlfAsMY4',
    },
    'Nueva Córdoba': {
      adr_address: 'Nueva Cordoba, <span class="locality">Córdoba</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Nueva Cordoba, Córdoba, Argentina',
      geometry: {
        location: {
          lat: -31.4240037,
          lng: -64.1844748,
        },
      },
      place_id: 'ChIJCwH5uI-iMpQRg6tJWowNjvM',
    },
    Observatorio: {
      adr_address: 'X5000BHE, <span class="street-address">Francisco N de Laprida 1515</span>, <span class="postal-code">X5000BHE</span> <span class="locality">Córdoba</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Barrio Observatorio, Córdoba, Argentina',
      geometry: {
        location: {
          lat: -31.4195627,
          lng: -64.2073324,
        },
      },
      place_id: 'ChIJxSGBhneiMpQRBGw3BEglF9s',
    },
    'Parque Sarmiento': {
      adr_address: '<span class="street-address">Deodoro Roca</span>, <span class="locality">Córdoba</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Barrio Parque Sarmiento, Córdoba, Argentina',
      geometry: {
        location: {
          lat: -31.42838450000001,
          lng: -64.1747778,
        },
      },
      place_id: 'ChIJN6i2hZSiMpQRidU-PUn3T9s',
    },
    Terminal: {
      adr_address: 'Terminal de Ómnibus de Córdoba, <span class="locality">Córdoba</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Terminal de Ómnibus de Córdoba, Córdoba, Argentina',
      geometry: {
        location: {
          lat: -31.422778,
          lng: -64.17527799999999,
        },
      },
      place_id: 'ChIJe2MiEpeiMpQRcsEG1Hoxgek',
    },
  },
  calafate: {
    Aeropuerto: {
      adr_address: '<span class="region">Santa Cruz</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Aeropuerto Internacional Comandante Armando Tola de El Calafate, Santa Cruz, Argentina',
      geometry: {
        location: {
          lat: -50.283977,
          lng: -72.0536406,
        },
      },
      place_id: 'ChIJk-6uLF6fu70R6WOqCrc1oms',
    },
    Centro: {
      adr_address: 'Calafate, <span class="locality">El Calafate</span>, <span class="region">Santa Cruz</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'El Calafate, Santa Cruz, Argentina',
      geometry: {
        location: {
          lat: -50.34506999999999,
          lng: -72.274544,
        },
      },

      place_id: 'ChIJR6tIeukMu70RRnSlnYCjZEg',
    },
    Terminal: {
      adr_address: '<span class="street-address">C. 510 87</span>, <span class="postal-code">Z9405</span> <span class="locality">El Calafate</span>, <span class="region">Santa Cruz</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Terminal de Omnibus El Calafate, Santa Cruz, Argentina',
      geometry: {
        location: {
          lat: -50.33740280000001,
          lng: -72.24520319999999,
        },
      },
      place_id: 'ChIJ4YoR2aEMu70RSUMU_Y72l34',
      utc_offset_minutes: -180,
    },
  },
  'mar-del-plata': {
    Aeropuerto: {
      adr_address: '<span class="street-address">Aeropuerto Mar del Plata</span>, <span class="locality">Mar del Plata</span>, <span class="region">Provincia de Buenos Aires</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Aeropuerto Mar del Plata, Mar del Plata, Provincia de Buenos Aires, Argentina',
      geometry: {
        location: {
          lat: -37.9336299,
          lng: -57.5843387,
        },
      },
      place_id: 'Ek1BZXJvcHVlcnRvIE1hciBkZWwgUGxhdGEsIE1hciBkZWwgUGxhdGEsIFByb3ZpbmNpYSBkZSBCdWVub3MgQWlyZXMsIEFyZ2VudGluYSIuKiwKFAoSCbvVIxzb2YSVEWC41fAKiGEREhQKEgkJQtMZTdmElREm0f5LgHCW3Q',
    },
    Centro: {
      adr_address: '<span class="locality">Mar del Plata</span>, <span class="region">Provincia de Buenos Aires</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Mar del Plata, Provincia de Buenos Aires, Argentina',
      geometry: {
        location: {
          lat: -38.0054771,
          lng: -57.5426106,
        },
      },
      place_id: 'ChIJCULTGU3ZhJURJtH-S4Bwlt0',
    },
    'Constitución / Museo MAR': {
      adr_address: 'Avenida Félix U. Camet, <span class="street-address">López de Gomara &amp;</span>, <span class="locality">Mar del Plata</span>, <span class="region">Provincia de Buenos Aires</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Avenida Félix U. Camet, López de Gomara &, Mar del Plata, Provincia de Buenos Aires, Argentina',
      geometry: {
        location: {
          lat: -37.97345069999999,
          lng: -57.54321599999999,
        },
      },
      place_id: 'ChIJE9hCza_bhJURtwAg-X87j7w',
    },
    Güemes: {
      adr_address: 'Martín Miguel de Güemes &amp; Alberti, <span class="locality">Mar del Plata</span>, <span class="region">Provincia de Buenos Aires</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Martín Miguel de Güemes & Alberti, Mar del Plata, Provincia de Buenos Aires, Argentina',
      geometry: {
        location: {
          lat: -38.0132603,
          lng: -57.5397985,
        },
      },
      place_id: 'ElhNYXJ0w61uIE1pZ3VlbCBkZSBHw7xlbWVzICYgQWxiZXJ0aSwgTWFyIGRlbCBQbGF0YSwgUHJvdmluY2lhIGRlIEJ1ZW5vcyBBaXJlcywgQXJnZW50aW5hImYiZAoUChIJj2m_DzvchJUR6FsV4gMXCMASFAoSCY9pvw873ISVEehbFeIDFwjAGhQKEgnFqYAEL9yElRHbAMbA9X0GGBoUChIJIYdEOjfZhJURGVnJ5UbAxiIiCg0Fo1fpFZ8ftN0',
    },
    Microcentro: {
      adr_address: '<span class="street-address">Peatonal San Martín</span>, <span class="locality">Mar del Plata</span>, <span class="region">Provincia de Buenos Aires</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Peatonal San Martín, Mar del Plata, Provincia de Buenos Aires, Argentina',
      geometry: {
        location: {
          lat: -38.0004825,
          lng: -57.5449099,
        },
      },
      place_id: 'EklQZWF0b25hbCBTYW4gTWFydMOtbiwgTWFyIGRlbCBQbGF0YSwgUHJvdmluY2lhIGRlIEJ1ZW5vcyBBaXJlcywgQXJnZW50aW5hIi4qLAoUChIJB51vbQPchJURsCbeiGIYG6kSFAoSCQlC0xlN2YSVESbR_kuAcJbd',
    },
    'Playa Chica / Playa Grande': {
      adr_address: '<span class="street-address">Av. Patricio Peralta Ramos S/N</span>, <span class="postal-code">B7600</span> <span class="locality">Mar del Plata</span>, <span class="region">Provincia de Buenos Aires</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Av. Patricio Peralta Ramos S/N, B7600 Mar del Plata, Provincia de Buenos Aires, Argentina',
      geometry: {
        location: {
          lat: -38.0236545,
          lng: -57.5291303,
        },
      },
      place_id: 'ChIJMzpIP7XdhJURaMS8bwFhIzE',
    },
    'Playa Varese': {
      adr_address: '<span class="street-address">P.º Jesús de Galindez 0</span>, <span class="postal-code">B7600</span> <span class="locality">Mar del Plata</span>, <span class="region">Provincia de Buenos Aires</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Playa Varese, Mar del Plata, Provincia de Buenos Aires, Argentina',
      geometry: {
        location: {
          lat: -38.0142542,
          lng: -57.530676,
        },
      },
      place_id: 'ChIJMY4rkzfchJURICM-ijVWZZ0',
    },
    'Terminal de Ómnibus': {
      adr_address: '<span class="street-address">San Juan 1473</span>, <span class="postal-code">B7600BVC</span> <span class="locality">Mar del Plata</span>, <span class="region">Provincia de Buenos Aires</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Terminal de Ómnibus, Mar del Plata, Provincia de Buenos Aires, Argentina',
      geometry: {
        location: {
          lat: -37.9893819,
          lng: -57.5633704,
        },
      },
      place_id: 'ChIJmQEx3y7ZhJURfC6FmffnPTo',
    },
  },
  mendoza: {
    'Área Fundacional': {
      adr_address: '<span class="street-address">Ituzaingó 2062</span>, <span class="postal-code">M5502GGL</span> <span class="locality">Mendoza</span>, <span class="country-name">Argentina</span>',

      formatted_address: 'Área Fundacional, Capital, Mendoza, Argentina',
      geometry: {
        location: {
          lat: -32.8796857,
          lng: -68.8290547,
        },
      },
      place_id: 'ChIJK1wVpyAJfpYRVDmynLV07_4',
    },
    'Barrio Cívico': {
      adr_address: '361, <span class="street-address">Virgen del Carmen de Cuyo 201</span>, <span class="locality">Capital</span>, <span class="region">Mendoza</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Barrio Cívico, Capital, Mendoza, Argentina',
      geometry: {
        location: {
          lat: -32.89745039999999,
          lng: -68.84622949999999,
        },
      },
      place_id: 'ChIJhTi45hEJfpYR_2KEyUx-Ifo',
    },

    Centro: {
      adr_address: '<span class="street-address">Gral. Espejo 300</span>, <span class="postal-code">M5502</span> <span class="locality">AVJ</span>, <span class="region">Mendoza</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Plaza Independencia, Mendoza, Argentina',
      geometry: {
        location: {
          lat: -32.8895571,
          lng: -68.8448326,
        },
      },
      place_id: 'ChIJSzL2swcJfpYRIfuNlSEVHVA',
    },
    'Godoy Cruz': {
      adr_address: 'Ciudad, <span class="locality">Godoy Cruz</span>, <span class="region">Mendoza</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Godoy Cruz, Mendoza, Argentina',
      geometry: {
        location: {
          lat: -32.9072213,
          lng: -68.8512959,
        },
      },
      place_id: 'ChIJJYSLdHMJfpYR4cEYfM9lPl4',
    },
    Guaymallén: {
      adr_address: '<span class="locality">Guaymallén</span>, <span class="region">Mendoza</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Guaymallén, Mendoza, Argentina',
      geometry: {
        location: {
          lat: -32.9028208,
          lng: -68.80470040000002,
        },
      },
      place_id: 'ChIJWXkGWbEOfpYR9wzhhjMouo4',
    },
    'Parque General San Martín': {
      adr_address: '<span class="street-address">Av Emilio Civit 701</span>, <span class="postal-code">M5500</span> <span class="locality">Mendoza</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Parque General San Martín, Capital, Mendoza, Argentina',
      geometry: {
        location: {
          lat: -32.8898095,
          lng: -68.8700868,
        },
      },
      place_id: 'ChIJf5QZdRgmo5URiQK7IWNggW0',
    },
    'Parque OHiggins': {
      adr_address: 'Ituzaingó &amp; San Luis, <span class="locality">Mendoza</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Parque OHiggins, Capital, Mendoza, Argentina',
      geometry: {
        location: {
          lat: -32.8844194,
          lng: -68.8291304,
        },
      },
      place_id: 'ChIJM2j6LCcJfpYRg1q6iE9rtuU',
    },
    Terminal: {
      adr_address: '<span class="street-address">Av. Gdor. Ricardo Videla</span>, <span class="postal-code">M5519</span> <span class="locality">Mendoza</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Terminal De Ómnibus de Mendoza, Mendoza, Argentina',
      geometry: {
        location: {
          lat: -32.8955869,
          lng: -68.8302405,
        },
      },
      place_id: 'ChIJ4xxdSTwJfpYRxkL7BjVUmHc',
    },
  },
  rosario: {
    Aeropuerto: {
      formatted_address: 'Aeropuerto Internacional Islas Malvinas, Santa Fe, Argentina',
      geometry: {
        location: {
          lat: -32.91695379999999,
          lng: -60.78039439999999,
        },
      },
      place_id: 'ChIJhwxSYJ1NtpURLue_ImHD3oE',
    },
    Centro: {
      adr_address: 'Centro, <span class="locality">Rosario</span>, <span class="region">Santa Fe</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Centro, Rosario, Santa Fe, Argentina',
      geometry: {
        location: {
          lat: -32.9502778,
          lng: -60.644229,
        },
      },
      place_id: 'ChIJGUTx3hWrt5URZtA--2FBMpc',
    },
    'Monumento Histórico Nacional a la Bandera': {
      adr_address: '<span class="street-address">Sta Fe 581</span>, <span class="postal-code">S2000</span> <span class="locality">Rosario</span>, <span class="region">Santa Fe</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Monumento Histórico Nacional a la Bandera, Rosario, Santa Fe, Argentina',
      geometry: {
        location: {
          lat: -32.9477132,
          lng: -60.6304658,
        },
      },
      place_id: 'ChIJb9O2yR2rt5URUdiUTVjpuZc',
    },
    'Parque de la Independencia': {
      adr_address: 'BUG, <span class="street-address">Av. Pellegrini 1901</span>, <span class="postal-code">S2000</span> <span class="locality">Rosario</span>, <span class="region">Santa Fe</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Parque de la Independencia, Rosario, Santa Fe, Argentina',
      geometry: {
        location: {
          lat: -32.9567281,
          lng: -60.65752790000001,
        },
      },
      place_id: 'ChIJiUohOnKrt5URTr5zqtFMdgI',
    },
    'Peatonal Córdoba': {
      adr_address: '<span class="street-address">Córdoba 1015</span>, <span class="postal-code">S2000</span> <span class="locality">Rosario</span>, <span class="region">Santa Fe</span>, <span class="country-name">Argentina</span>',

      formatted_address: 'Córdoba 1015, S2000 Rosario, Santa Fe, Argentina',
      geometry: {
        location: {
          lat: -32.9468257,
          lng: -60.63684809999999,
        },
      },
      place_id: 'ChIJd_C-vhOrt5URYI7p_-I43Z8',
    },
    'Ribera céntrica': {
      adr_address: '<span class="postal-code">S2000</span> <span class="locality">Rosario</span>, <span class="region">Santa Fe</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Parque de España, Rosario, Santa Fe, Argentina',
      formatted_phone_number: '0341 426-0941',
      geometry: {
        location: {
          lat: -32.93797959999999,
          lng: -60.6380804,
        },
      },
      place_id: 'ChIJR4ftnCSrt5URFU-wsIZj_OI',
    },
    'Terminal de ómnibus': {
      adr_address: 'Santa Fe, <span class="postal-code">S3000</span> <span class="locality">Rosario</span>, <span class="region">Santa Fe</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Terminal de Ómnibus, Rosario, Santa Fe, Argentina',
      geometry: {
        location: {
          lat: -32.9391905,
          lng: -60.6726608,
        },
      },
      place_id: 'ChIJPTN7sVert5URiY3tsKWDK18',
    },
    'Zona Norte': {
      adr_address: '199,, <span class="street-address">Av. Francia Bis 175</span>, <span class="locality">Rosario</span>, <span class="region">Santa Fe</span>, <span class="country-name">Argentina</span>',
      formatted_address: 'Puerto Norte, Rosario, Santa Fe, Argentina',
      geometry: {
        location: {
          lat: -32.9252215,
          lng: -60.66147410000001,
        },
      },
      place_id: 'ChIJCzEVa02rt5URBcI5vkQMWAI',
    },
  },

  //  MÉXICO
  cdmx: {
    Aeropuerto: {
      adr_address: '<span class="street-address">Aeropuerto Internacional de la Ciudad de México</span>, <span class="extended-address">Benito Juárez</span>,<span class="locality">Ciudad de México</span>, <span class="region">CDMX</span>, <span class="country-name">México</span>',
      formatted_address: 'Aeropuerto Internacional de la Ciudad de México - Benito Juárez, Ciudad de México, CDMX, México',
      geometry: {
        location: {
          lat: 19.4360762,
          lng: -99.07190829999999,
        },
      },
      place_id: 'ChIJnyKTvXf80YURRNK6YfV-0AI',
    },
    'Ángel de la Independencia': {
      adr_address: '<span class="street-address">Ángel de la Independencia</span>, <span class="extended-address">Juárez</span>, <span class="locality">Ciudad de México</span>, <span class="region">CDMX</span>, <span class="country-name">México</span>',
      formatted_address: 'Ángel de la Independencia, Juárez, Ciudad de México, CDMX, México',
      geometry: {
        location: {
          lat: 19.4271988,
          lng: -99.1673144,
        },
      },
      place_id: 'EkTDgW5nZWwgZGUgbGEgSW5kZXBlbmRlbmNpYSwgSnXDoXJleiwgQ2l1ZGFkIGRlIE3DqXhpY28sIENETVgsIE1leGljbyIuKiwKFAoSCb-5lfU1_9GFEXyDJVIlSIecEhQKEgkHBIpvNP_RhREvxwXtzs1y2Q',
    },
    'Basílica de Guadalupe': {
      adr_address: '<span class="street-address">Basílica de Guadalupe</span>, <span class="extended-address">Villa Gustavo A. Madero</span>, <span class="region">Gustavo A. Madero</span>, <span class="postal-code">07050</span> <span class="locality">Ciudad de México</span>, <span class="region">CDMX</span>, <span class="country-name">México</span>',
      formatted_address: 'Basílica de Guadalupe, Villa Gustavo A. Madero, Gustavo A. Madero, 07050 Ciudad de México, CDMX, México',
      geometry: {
        location: {
          lat: 19.4848572,
          lng: -99.1178616,
        },
      },
      place_id: 'ChIJxak0Kpz50YURsGoopfnqoCE',
    },
    'Centro Histórico': {
      adr_address: '<span class="extended-address">Centro Histórico de la Cdad. de México, Centro</span>, <span class="locality">Ciudad de México</span>, <span class="region">CDMX</span>, <span class="country-name">México</span>',
      formatted_address: 'Centro Histórico de la Cdad. de México, Centro, Ciudad de México, CDMX, México',
      geometry: {
        location: {
          lat: 19.4357068,
          lng: -99.131757,
        },
      },
      place_id: 'ChIJvU0OLi350YURPYnEQKd0VZA',
    },
    'Bosque de Chapultepec': {
      adr_address: '<span class="region">Bosque de Chapultepec, Miguel Hidalgo</span>, <span class="locality">Ciudad de México</span>, <span class="region">CDMX</span>, <span class="country-name">México</span>',
      formatted_address: 'Bosque de Chapultepec, Miguel Hidalgo, Ciudad de México, CDMX, México',
      geometry: {
        location: {
          lat: 19.4194815,
          lng: -99.18945579999999,
        },
      },
      place_id: 'ChIJP1dJRVf_0YURr8MZosHl4kI',
    },
    Condesa: {
      adr_address: '<span class="extended-address">Colonia Condesa</span>, <span class="locality">Ciudad de México</span>, <span class="region">CDMX</span>, <span class="country-name">México</span>',
      formatted_address: 'Colonia Condesa, Ciudad de México, CDMX, México',
      geometry: {
        location: {
          lat: 19.4149803,
          lng: -99.17744619999999,
        },
      },
      place_id: 'ChIJ4zXmiUT_0YUR57jJi24HHO0',
    },
    Coyoacán: {
      adr_address: '<span class="extended-address">Coyoacán</span>, <span class="locality">Ciudad de México</span>, <span class="region">CDMX</span>, <span class="country-name">México</span>',
      formatted_address: 'Coyoacán, Ciudad de México, CDMX, México',
      geometry: {
        location: {
          lat: 19.3486926,
          lng: -99.16291310000001,
        },
      },
      place_id: 'ChIJAd0jvtz_0YURkB_9OyD0xd4',
    },
    Cuauhtémoc: {
      adr_address: '<span class="extended-address">Cuauhtémoc</span>, <span class="postal-code">06500</span> <span class="locality">Ciudad de México</span>, <span class="region">CDMX</span>, <span class="country-name">México</span>',
      formatted_address: 'Cuauhtémoc, 06500 Ciudad de México, CDMX, México',
      geometry: {
        location: {
          lat: 19.4301322,
          lng: -99.16914129999999,
        },
      },
      place_id: 'ChIJ_YE7tMr40YURtHtXg6cgsOU',
    },
    Polanco: {
      adr_address: '<span class="extended-address">Polanco, Polanco I Secc</span>, <span class="locality">Ciudad de México</span>, <span class="region">CDMX</span>, <span class="country-name">México</span>',
      formatted_address: 'Polanco, Polanco I Secc, Ciudad de México, CDMX, México',
      geometry: {
        location: {
          lat: 19.4340199,
          lng: -99.19560120000001,
        },
      },
      place_id: 'ChIJ-UNIbQMC0oURdqnTwDJ30-Q',
    },
    Roma: {
      adr_address: '<span class="extended-address">Roma Nte.</span>, <span class="postal-code">06700</span> <span class="locality">Ciudad de México</span>, <span class="region">CDMX</span>, <span class="country-name">México</span>',
      formatted_address: 'Roma Nte., 06700 Ciudad de México, CDMX, México',
      geometry: {
        location: {
          lat: 19.4195256,
          lng: -99.162549,
        },
      },
      place_id: 'ChIJzeSi8jn_0YURMiXDZ-gzmi0',
    },
    'Universidad UNAM': {
      adr_address: '<span class="street-address">Av. Universidad 3004</span>, <span class="extended-address">Copilco Universidad</span>, <span class="region">Coyoacán</span>, <span class="postal-code">04510</span> <span class="locality">Ciudad de México</span>, <span class="region">CDMX</span>, <span class="country-name">México</span>',
      formatted_address: 'Av. Universidad 3004, Copilco Universidad, Coyoacán, 04510 Ciudad de México, CDMX, México',
      geometry: {
        location: {
          lat: 19.3365296,
          lng: -99.1886248,
        },
      },
      place_id: 'ChIJoVxf4P__0YUR2vJ4ww77744',
    },
    Zócalo: {
      adr_address: '<span class="street-address">P.za de la Constitución S/N</span>, <span class="extended-address">Centro Histórico de la Cdad. de México, Centro</span>, <span class="region">Cuauhtémoc</span>, <span class="postal-code">06010</span> <span class="locality">Ciudad de México</span>, <span class="region">CDMX</span>, <span class="country-name">México</span>',
      formatted_address: 'P.za de la Constitución S/N, Centro Histórico de la Cdad. de México, Centro, Cuauhtémoc, 06010 Ciudad de México, CDMX, México',
      geometry: {
        location: {
          lat: 19.4326018,
          lng: -99.1332049,
        },
      },
      place_id: 'ChIJ_6pkSM3-0YURDDaRslwM_0w',
    },
  },
  cancun: {
    Aeropuerto: {
      adr_address: '<span class="street-address">Aeropuerto Internacional de Cancún</span>, <span class="postal-code">77565</span> <span class="locality">Cancún</span>, <span class="region">Q.R.</span>, <span class="country-name">México</span>',
      formatted_address: 'Aeropuerto Internacional de Cancún, 77565 Cancún, Q.R., México',
      geometry: {
        location: {
          lat: 21.0417033,
          lng: -86.8740062,
        },
      },
      place_id: 'ChIJvwmEZ0eATo8RkrvqeK_-1F8',
    },
    Centro: {
      adr_address: '<span class="locality">Cancún</span>, <span class="region">Q.R.</span>, <span class="country-name">México</span>',
      formatted_address: 'Cancún, Q.R., México',
      geometry: {
        location: {
          lat: 21.161908,
          lng: -86.8515279,
        },
      },
      place_id: 'ChIJ21P2rgUrTI8Ris1fYjy3Ms4',
    },
    'Isla Mujeres': {
      adr_address: '<span class="locality">Isla Mujeres</span>, <span class="region">Q.R.</span>, <span class="country-name">México</span>',
      formatted_address: 'Isla Mujeres, Q.R., México',
      geometry: {
        location: {
          lat: 21.2366946,
          lng: -86.7357679,
        },
      },
      place_id: 'ChIJ07LODlclTI8Re4xeoiXrcFg',
    },
    'Playa del Carmen': {
      adr_address: '<span class="locality">Playa del Carmen</span>, <span class="region">Q.R.</span>, <span class="country-name">México</span>',
      formatted_address: 'Playa del Carmen, Q.R., México',
      geometry: {
        location: {
          lat: 20.6295586,
          lng: -87.0738851,
        },
      },
      place_id: 'ChIJYU4t0iNDTo8R3EqrO3gLweg',
    },
    'Playa Delfines': {
      adr_address: '<span class="street-address">Playa Delfines</span>, <span class="extended-address">Zona Hotelera</span>, <span class="postal-code">77500</span> <span class="locality">Cancún</span>, <span class="region">Q.R.</span>, <span class="country-name">México</span>',
      formatted_address: 'Playa Delfines, Zona Hotelera, 77500 Cancún, Q.R., México',
      geometry: {
        location: {
          lat: 21.0608654,
          lng: -86.7795105,
        },
      },
      place_id: 'ChIJTc0cUYCCTo8R5IF6JQxSq-Q',
    },
    'Playa Gaviota Azul': {
      adr_address: 'Playa Gaviota Azul, <span class="extended-address">Punta Cancun</span>, <span class="locality">Cancún</span>, <span class="region">Q.R.</span>, <span class="country-name">México</span>',
      formatted_address: 'Playa Gaviota Azul, Punta Cancun, Cancún, Q.R., México',
      geometry: {
        location: {
          lat: 21.1333959,
          lng: -86.7421964,
        },
      },
      place_id: 'ChIJNUBD5Z8oTI8RebUh_CXRlEI',
    },
    'Playa Linda': {
      adr_address: '<span class="street-address">Blvd. Kukulcan Km. 4</span>, <span class="extended-address">Kukulcan Boulevard, Zona Hotelera</span>, <span class="postal-code">77500</span> <span class="locality">Cancún</span>, <span class="region">Q.R.</span>, <span class="country-name">México</span>',
      formatted_address: 'Blvd. Kukulcan Km. 4, Kukulcan Boulevard, Zona Hotelera, 77500 Cancún, Q.R., México',
      geometry: {
        location: {
          lat: 21.145566,
          lng: -86.7880406,
        },
      },
      place_id: 'ChIJWZ0xeTMpTI8RO1nGcfpLeJA',
    },
    'Puerto Juárez': {
      adr_address: '<span class="extended-address">Puerto Juarez, Juárez</span>, <span class="postal-code">77525</span> <span class="locality">Cancún</span>, <span class="region">Q.R.</span>, <span class="country-name">México</span>',
      formatted_address: 'Puerto Juarez, Juárez, 77525 Cancún, Q.R., México',
      geometry: {
        location: {
          lat: 21.182353,
          lng: -86.80862599999999,
        },
      },
      place_id: 'ChIJH4RBjr0uTI8RmM_PcdoGezc',
    },
    'San Miguel de Cozumel': {
      adr_address: '<span class="locality">San Miguel de Cozumel</span>, <span class="region">Q.R.</span>, <span class="country-name">México</span>',
      formatted_address: 'San Miguel de Cozumel, Q.R., México',
      geometry: {
        location: {
          lat: 20.5071703,
          lng: -86.9446237,
        },
      },
      place_id: 'ChIJWTZnCjNYTo8Rmm7Yxxb17Zw',
    },
    'Terminal de Ómnibus': {
      adr_address: 'Terminal ADO Cancun, <span class="street-address">Pino SM 23</span>, <span class="postal-code">77500</span> <span class="locality">Cancún</span>, <span class="region">Q.R.</span>, <span class="country-name">México</span>',
      formatted_address: 'Terminal ADO Cancun, Pino Supermanzana 23, 77500 Cancún, Q.R., México',
      geometry: {
        location: {
          lat: 21.1643537,
          lng: -86.8265763,
        },
      },
      place_id: 'ChIJByjGSAEsTI8R-Yf0RwI2TqE',
    },
    Tulum: {
      adr_address: '<span class="locality">Tulum</span>, <span class="region">Q.R.</span>, <span class="country-name">México</span>',
      formatted_address: 'Tulum, Q.R., México',
      geometry: {
        location: {
          lat: 20.2114185,
          lng: -87.46535019999999,
        },
      },
      place_id: 'ChIJSyrkEAPUT48Rt5r_k9vA7Q4',
    },
    'Zona Hotelera': {
      adr_address: '<span class="extended-address">Zona Hotelera</span>, <span class="locality">Cancún</span>, <span class="region">Q.R.</span>, <span class="country-name">México</span>',
      formatted_address: 'Zona Hotelera, Cancún, Q.R., México',
      geometry: {
        location: {
          lat: 21.1347621,
          lng: -86.7461357,
        },
      },
      place_id: 'ChIJ-QkgQqwpTI8RP4Vc1kQxZy4',
    },
  },
  guadalajara: {
    Aeropuerto: {
      adr_address: '<span class="street-address">Aeropuerto Internacional de Guadalajara Miguel Hidalgo y Costilla</span>, <span class="postal-code">45659</span> <span class="region">Jal.</span>, <span class="country-name">México</span>',
      formatted_address: 'Aeropuerto Internacional de Guadalajara Miguel Hidalgo y Costilla, 45659 Jal., México',
      geometry: {
        location: {
          lat: 20.5259561,
          lng: -103.307625,
        },
      },
      place_id: 'ChIJaQAk1apNL4QRnW99Ljn8FEw',
    },
    'Arcos Vallarta Guadalajara': {
      adr_address: '<span class="extended-address">Arcos Vallarta</span>, <span class="locality">Guadalajara</span>, <span class="region">Jal.</span>, <span class="country-name">México</span>',
      formatted_address: 'Arcos Vallarta, Guadalajara, Jal., México',
      geometry: {
        location: {
          lat: 20.6733373,
          lng: -103.3803903,
        },
      },
      place_id: 'ChIJHWtRPg2uKIQR2rxdVb_BuDQ',
    },
    Centro: {
      adr_address: '<span class="extended-address">Zona Centro</span>, <span class="postal-code">44100</span> <span class="locality">Guadalajara</span>, <span class="region">Jal.</span>, <span class="country-name">México</span>',
      formatted_address: 'Zona Centro, 44100 Guadalajara, Jal., México',
      geometry: {
        location: {
          lat: 20.6770286,
          lng: -103.346942,
        },
      },
      place_id: 'ChIJQTsMJfSxKIQRCEhqST3wiOw',
    },
    'Mercado de San Juan de Dios': {
      adr_address: '<span class="street-address">C. Dionisio Rodríguez 52</span>, <span class="extended-address">San Juan de Dios</span>, <span class="postal-code">44360</span> <span class="locality">Guadalajara</span>, <span class="region">Jal.</span>, <span class="country-name">México</span>',
      formatted_address: 'C. Dionisio Rodríguez 52, San Juan de Dios, 44360 Guadalajara, Jal., México',
      geometry: {
        location: {
          lat: 20.6755148,
          lng: -103.3398522,
        },
      },
      place_id: 'ChIJFVwZ-ICxKIQRAzVGpT436bM',
    },
    Tlaquepaque: {
      adr_address: '<span class="extended-address">Centro</span>, <span class="postal-code">45500</span> <span class="locality">San Pedro Tlaquepaque</span>, <span class="region">Jal.</span>, <span class="country-name">México</span>',
      formatted_address: 'Centro, 45500 San Pedro Tlaquepaque, Jal., México',
      geometry: {
        location: {
          lat: 20.6392424,
          lng: -103.3120956,
        },
      },
      place_id: 'ChIJNVRw9wyzKIQRa2tOfmUGxLM',
    },
    Tonalá: {
      adr_address: '<span class="extended-address">Tonalá Centro</span>, <span class="locality">Tonalá</span>, <span class="region">Jal.</span>, <span class="country-name">México</span>',
      formatted_address: 'Tonalá Centro, Tonalá, Jal., México',
      geometry: {
        location: {
          lat: 20.6243894,
          lng: -103.2403779,
        },
      },
      place_id: 'ChIJ6VAZsYq0KIQRaGp--BOOeYI',
    },
    Zapopan: {
      adr_address: '<span class="extended-address">Zapopan</span>, <span class="postal-code">45100</span> <span class="locality">Zapopan</span>, <span class="region">Jal.</span>, <span class="country-name">México</span>',
      formatted_address: 'Zapopan, 45100 Zapopan, Jal., México',
      geometry: {
        location: {
          lat: 20.7220746,
          lng: -103.3919446,
        },
      },
      place_id: 'ChIJv1Q3xbqvKIQROO7zgvxBCYg',
    },
  },

  //  COLOMBIA
  medellin: {
    'Aeropuerto Internacional de Medellín': {
      adr_address: 'Oriente de Medellín, <span class="locality">Medellín, Rionegro</span>, <span class="region">Antioquia</span>, <span class="postal-code">054047</span>, <span class="country-name">Colombia</span>',
      formatted_address: 'Oriente de Medellín, Medellín, Rionegro, Antioquia, Colombia',
      geometry: {
        location: {
          lat: 6.171332,
          lng: -75.42744979999999,
        },
      },
      place_id: 'ChIJIZJ2kuufRo4RVyxmuRvjXuI',
    },
    'Aeropuerto Olaya Herrera Medellín': {
      adr_address: '<span class="street-address">Carrera 65 #13-157</span>, <span class="region">Guayabal</span>, <span class="locality">Medellín, Guayabal, Medellín</span>, <span class="region">Antioquia</span>, <span class="postal-code">050040</span>, <span class="country-name">Colombia</span>',
      formatted_address: 'Cra. 65 #13-157, Guayabal, Medellín, Guayabal, Medellín, Antioquia, Colombia',
      geometry: {
        location: {
          lat: 6.219058299999999,
          lng: -75.5868332,
        },
      },
      place_id: 'ChIJLWXlT8UpRI4RUE6zcomDY1M',
    },
    'Terminal del Norte': {
      adr_address: '<span class="street-address">Vías Terminal del Norte</span>, <span class="region">Oleoducto</span>, <span class="locality">Medellín, Castilla, Medellín</span>, <span class="region">Antioquia</span>, <span class="postal-code">050040</span>, <span class="country-name">Colombia</span>',
      formatted_address: 'Vías Terminal del Nte., Oleoducto, Medellín, Castilla, Medellín, Antioquia, Colombia',
      geometry: {
        location: {
          lat: 6.2786446,
          lng: -75.57068439999999,
        },
      },
      place_id: 'EldWw61hcyBUZXJtaW5hbCBkZWwgTnRlLiwgT2xlb2R1Y3RvLCBNZWRlbGzDrW4sIENhc3RpbGxhLCBNZWRlbGzDrW4sIEFudGlvcXVpYSwgQ29sb21iaWEiLiosChQKEgkHHeXO2ShEjhEUXGQ75oYeqBIUChIJPymRE9coRI4RP2qrqALfIDc',
    },
    'Terminal del Sur': {
      adr_address: '<span class="street-address">Terminal del Sur</span>, <span class="region">Guayabal</span>, <span class="locality">Medellín, Guayabal, Medellín</span>, <span class="region">Antioquia</span>, <span class="postal-code">050024</span>, <span class="country-name">Colombia</span>',
      formatted_address: 'Terminal del Sur, Guayabal, Medellín, Guayabal, Medellín, Antioquia, Colombia',
      geometry: {
        location: {
          lat: 6.2165971,
          lng: -75.58866019999999,
        },
      },
      place_id: 'Ek9UZXJtaW5hbCBkZWwgU3VyLCBHdWF5YWJhbCwgTWVkZWxsw61uLCBHdWF5YWJhbCwgTWVkZWxsw61uLCBBbnRpb3F1aWEsIENvbG9tYmlhIi4qLAoUChIJafox59opRI4RlcoD80NUXTUSFAoSCS3Z5ybaKUSOETEmpUg_iu_1',
    },
    'La Candelaria': {
      adr_address: '<span class="region">La Candelaria</span>, <span class="locality">Medellín, La Candelaria, Medellín</span>, <span class="region">Antioquia</span>, <span class="postal-code">050015</span>, <span class="country-name">Colombia</span>',
      formatted_address: 'La Candelaria, Medellín, La Candelaria, Medellín, Antioquia, Colombia',
      geometry: {
        location: {
          lat: 6.243528999999999,
          lng: -75.5713677,
        },
      },
      place_id: 'ChIJgzRrhlQoRI4RXc5YOIVgvxc',
    },
    'Parque Lleras': {
      adr_address: '<span class="street-address">Parque Lleras</span>, <span class="region">El Poblado</span>, <span class="locality">Medellín, El Poblado, Medellín</span>, <span class="region">Antioquia</span>, <span class="postal-code">050021</span>, <span class="country-name">Colombia</span>',
      formatted_address: 'Parque Lleras, El Poblado, Medellín, El Poblado, Medellín, Antioquia, Colombia',
      geometry: {
        location: {
          lat: 6.2089814,
          lng: -75.5679567,
        },
      },
      place_id: 'ElBQYXJxdWUgTGxlcmFzLCBFbCBQb2JsYWRvLCBNZWRlbGzDrW4sIEVsIFBvYmxhZG8sIE1lZGVsbMOtbiwgQW50aW9xdWlhLCBDb2xvbWJpYSIuKiwKFAoSCUV-Bo8pKESOEaZ_vWY1YmdcEhQKEglviyCaKShEjhENF5yOXhgi3w',
    },
    Belén: {
      adr_address: 'Belén, <span class="locality">Medellín, Belén, Medellín</span>, <span class="region">Antioquia</span>, <span class="postal-code">050030</span>, <span class="country-name">Colombia</span>',
      formatted_address: 'Belén, Medellín, Belén, Medellín, Antioquia, Colombia',
      geometry: {
        location: {
          lat: 6.231513700000001,
          lng: -75.5914068,
        },
      },
      place_id: 'ChIJtzzMLbkpRI4R8WhxkiPLDis',
    },
  },
  bogota: {
    'Aeropuerto Internacional El Dorado': {
      adr_address: '<span class="street-address">Avenida El Dorado #103-9</span>, <span class="region">Fontibón</span>, <span class="locality">Bogotá</span>, <span class="postal-code">110911</span>, <span class="country-name">Colombia</span>',
      formatted_address: 'Av. El Dorado #103-9, Fontibón, Bogotá, Colombia',
      geometry: {
        location: {
          lat: 4.7009694,
          lng: -74.146093,
        },
      },
      place_id: 'ChIJB4YPQ7acP44RMK8U71RZ6o4',
    },
    'Terminal De Transportes Bogotá': {
      adr_address: '<span class="street-address">Calle 22b #6998</span> #69- a, <span class="locality">Bogotá</span>, <span class="postal-code">110931</span>, <span class="country-name">Colombia</span>',
      formatted_address: 'Cl. 22b #6998 #69- a, Bogotá, Colombia',
      geometry: {
        location: {
          lat: 4.6535928,
          lng: -74.11473769999999,
        },
      },
      place_id: 'ChIJLUxZfI6bP44RdUPxyzRTnCo',
    },
    'La Candelaria': {
      adr_address: '<span class="region">La Candelaria</span>, <span class="locality">Bogotá</span>, <span class="country-name">Colombia</span>',
      formatted_address: 'La Candelaria, Bogotá, Colombia',
      geometry: {
        location: {
          lat: 4.597014,
          lng: -74.0728759,
        },
      },
      place_id: 'ChIJy3nPRKiZP44RMROn2mQYjaU',
    },
    'Centro Histórico Bogotá': {
      adr_address: '<span class="street-address">Calle 9 #312</span>, <span class="locality">Bogotá</span>, <span class="postal-code">111711</span>, <span class="country-name">Colombia</span>',
      formatted_address: 'Cl. 9 #312, Bogotá, Colombia',
      geometry: {
        location: {
          lat: 4.592057299999999,
          lng: -74.0701136,
        },
      },
      place_id: 'ChIJN8WGpq6ZP44RPc2BajM75f4',
    },
    Chapinero: {
      geometry: {
        location: {
          lat: 4.6548153,
          lng: -74.0552684,
        },
      },
      formatted_address: 'Localidad de Chapinero, Bogotá, Colombia',
    },
    Chicó: {
      adr_address: 'Rincón del Chico, <span class="region">Localidad de Chapinero</span>, <span class="locality">Bogotá</span>, <span class="postal-code">110221</span>, <span class="country-name">Colombia</span>',
      formatted_address: 'Rincón del Chico, Localidad de Chapinero, Bogotá, Colombia',
      geometry: {
        location: {
          lat: 4.6759273,
          lng: -74.0525124,
        },
      },
      place_id: 'ChIJnT1oVO2aP44R92gXjmZ0QKc',
    },
    Usaquén: {
      adr_address: '<span class="region">Usaquén</span>, <span class="locality">Bogotá</span>, <span class="country-name">Colombia</span>',
      formatted_address: 'Usaquén, Bogotá, Colombia',
      geometry: {
        location: {
          lat: 4.703336699999999,
          lng: -74.0328803,
        },
      },
      place_id: 'ChIJ61tOXYCPP44Rb3xHQhxhUwg',
    },
    'Zona Rosa o T': {
      adr_address: '<span class="street-address">Calle 81 #11 – 68</span> Of. 607, <span class="locality">Bogotá</span>, <span class="postal-code">110221</span>, <span class="country-name">Colombia</span>',
      formatted_address: 'Cl. 81 #11 – 68 Of. 607, Bogotá, Colombia',
      geometry: {
        location: {
          lat: 4.665571000000001,
          lng: -74.0539936,
        },
      },
      place_id: 'ChIJ03zL5F-aP44RdiDzaw4B77g',
    },

  },
  cartagena: {
    'Aeropuerto Rafael Núñez': {
      adr_address: '<span class="locality">Cartagena, Provincia de Cartagena</span>, <span class="region">Bolívar</span>, <span class="postal-code">130002</span>, <span class="country-name">Colombia</span>',
      formatted_address: 'Cartagena, Provincia de Cartagena, Bolívar, Colombia',
      geometry: {
        location: {
          lat: 10.4463149,
          lng: -75.5164539,
        },
      },
      place_id: 'ChIJv-dqFBYl9o4RaTJn2Gf2XZ8',
    },
    'Boca Grande': {
      adr_address: 'Bocagrande, <span class="locality">Cartagena de Indias, Provincia de Cartagena</span>, <span class="region">Bolívar</span>, <span class="country-name">Colombia</span>',
      formatted_address: 'Bocagrande, Cartagena de Indias, Provincia de Cartagena, Bolívar, Colombia',
      geometry: {
        location: {
          lat: 10.4101185,
          lng: -75.5505696,
        },
      },
      place_id: 'ChIJ3zVahBMv9o4RpkCNkcGXpqg',
    },
    'Centro Cartagena': {
      adr_address: '<span class="region">Centro</span>, <span class="locality">Cartagena, Cartagena Province</span>, <span class="region">Bolivar</span>, <span class="country-name">Colombia</span>',
      formatted_address: 'Centro, Cartagena, Cartagena Province, Bolivar, Colombia',
      geometry: {
        location: {
          lat: 10.4229301,
          lng: -75.5502324,
        },
      },
      place_id: 'ChIJL_283Z8v9o4RN-1ZMVMtnLo',
    },
    Getsemaní: {
      adr_address: '<span class="region">Getsemaní</span>, <span class="locality">Cartagena de Indias, Provincia de Cartagena</span>, <span class="region">Bolívar</span>, <span class="country-name">Colombia</span>',
      formatted_address: 'Getsemaní, Cartagena de Indias, Provincia de Cartagena, Bolívar, Colombia',
      geometry: {
        location: {
          lat: 10.4199938,
          lng: -75.5458657,
        },
      },
      place_id: 'ChIJyWXrWHMv9o4RnIUIGezZ6Lk',
    },
    'El Laguito': {
      adr_address: '<span class="region">El Laguito</span>, <span class="locality">Cartagena, Cartagena Province</span>, <span class="region">Bolivar</span>, <span class="country-name">Colombia</span>',
      formatted_address: 'El Laguito, Cartagena, Cartagena Province, Bolivar, Colombia',
      geometry: {
        location: {
          lat: 10.3950965,
          lng: -75.56224,
        },
      },
      place_id: 'ChIJDW3spCQv9o4RDIlKqCHYdo8',
    },
    Castillogrande: {
      adr_address: '<span class="region">Castillogrande</span>, <span class="locality">Cartagena, Cartagena Province</span>, <span class="region">Bolivar</span>, <span class="country-name">Colombia</span>',
      formatted_address: 'Castillogrande, Cartagena, Cartagena Province, Bolivar, Colombia',
      geometry: {
        location: {
          lat: 10.3942723,
          lng: -75.55168789999999,
        },
      },
      place_id: 'ChIJ9fVp6zgv9o4RfPviQezf6mY',
    },
    'Barrio de Crespo': {
      adr_address: 'Br. de Crespo, <span class="region">Marbella</span>, <span class="locality">Cartagena de Indias, Provincia de Cartagena</span>, <span class="region">Bolívar</span>, <span class="postal-code">130002</span>, <span class="country-name">Colombia</span>',
      formatted_address: 'Br. de Crespo, Marbella, Cartagena de Indias, Provincia de Cartagena, Bolívar, Colombia',
      geometry: {
        location: {
          lat: 10.44997,
          lng: -75.51666999999999,
        },
      },
      place_id: 'ChIJxT_DZFwl9o4R47F0pwHkmVU',
    },
  },
  'santa-marta': {
    'Aeropuerto Internacional Simón Bolívar': {
      adr_address: '<span class="street-address">Centro Histórico</span>, <span class="locality">Santa Marta</span>, <span class="region">Magdalena</span>, <span class="postal-code">470002</span>, <span class="country-name">Colombia</span>',
      formatted_address: 'Centro Histórico, Santa Marta, Magdalena, Colombia',
      geometry: {
        location: {
          lat: 11.2448267,
          lng: -74.2117865,
        },
      },
      place_id: 'ChIJnUEnzwb19I4RgyjQ_3ECRVw',
    },
    'Bahía Concha': {
      adr_address: '<span class="street-address">Centro Histórico</span>, <span class="locality">Santa Marta</span>, <span class="region">Magdalena</span>, <span class="postal-code">470002</span>, <span class="country-name">Colombia</span>',
      formatted_address: 'Centro Histórico, Santa Marta, Magdalena, Colombia',
      geometry: {
        location: {
          lat: 11.2448267,
          lng: -74.2117865,
        },
      },
      place_id: 'ChIJnUEnzwb19I4RgyjQ_3ECRVw',
    },
    'Centro Histórico': {
      adr_address: '<span class="street-address">Centro Histórico</span>, <span class="locality">Santa Marta</span>, <span class="region">Magdalena</span>, <span class="postal-code">470002</span>, <span class="country-name">Colombia</span>',
      formatted_address: 'Centro Histórico, Santa Marta, Magdalena, Colombia',
      geometry: {
        location: {
          lat: 11.2448267,
          lng: -74.2117865,
        },
      },
      place_id: 'ChIJnUEnzwb19I4RgyjQ_3ECRVw',
    },
    'Ciudad Perdida': {
      adr_address: '<span class="street-address">Centro Histórico</span>, <span class="locality">Santa Marta</span>, <span class="region">Magdalena</span>, <span class="postal-code">470002</span>, <span class="country-name">Colombia</span>',
      formatted_address: 'Centro Histórico, Santa Marta, Magdalena, Colombia',
      geometry: {
        location: {
          lat: 11.2448267,
          lng: -74.2117865,
        },
      },
      place_id: 'ChIJnUEnzwb19I4RgyjQ_3ECRVw',
    },
    'Parque Tayrona': {
      adr_address: '<span class="street-address">Centro Histórico</span>, <span class="locality">Santa Marta</span>, <span class="region">Magdalena</span>, <span class="postal-code">470002</span>, <span class="country-name">Colombia</span>',
      formatted_address: 'Centro Histórico, Santa Marta, Magdalena, Colombia',
      geometry: {
        location: {
          lat: 11.2448267,
          lng: -74.2117865,
        },
      },
      place_id: 'ChIJnUEnzwb19I4RgyjQ_3ECRVw',
    },
    'Playa Blanca': {
      adr_address: '<span class="street-address">Centro Histórico</span>, <span class="locality">Santa Marta</span>, <span class="region">Magdalena</span>, <span class="postal-code">470002</span>, <span class="country-name">Colombia</span>',
      formatted_address: 'Centro Histórico, Santa Marta, Magdalena, Colombia',
      geometry: {
        location: {
          lat: 11.2448267,
          lng: -74.2117865,
        },
      },
      place_id: 'ChIJnUEnzwb19I4RgyjQ_3ECRVw',
    },
    Taganga: {
      adr_address: '<span class="street-address">Centro Histórico</span>, <span class="locality">Santa Marta</span>, <span class="region">Magdalena</span>, <span class="postal-code">470002</span>, <span class="country-name">Colombia</span>',
      formatted_address: 'Centro Histórico, Santa Marta, Magdalena, Colombia',
      geometry: {
        location: {
          lat: 11.2448267,
          lng: -74.2117865,
        },
      },
      place_id: 'ChIJnUEnzwb19I4RgyjQ_3ECRVw',
    },
  },

  //  CHILE
  santiago: {
    'Aeropuerto Internacional Arturo Merino Benitez': {
      adr_address: '<span class="street-address">Aeropuerto Internacional Arturo Merino Benitez</span>, <span class="region">Región Metropolitana</span>, <span class="country-name">Chile</span>',
      formatted_address: 'Aeropuerto Internacional Arturo Merino Benitez, Chile',
      geometry: {
        location: {
          lat: -33.4019692,
          lng: -70.7928084,
        },
      },
      place_id: 'ChIJO2DomMbBYpYR5amfsYHN8V8',
    },
    'Estación Central': {
      adr_address: 'Estación Central, <span class="locality">Santiago, Estación Central</span>, <span class="region">Región Metropolitana</span>, <span class="country-name">Chile</span>',
      formatted_address: 'Estación Central, Santiago, Estación Central, Región Metropolitana, Chile',
      geometry: {
        location: {
          lat: -33.4530716,
          lng: -70.6829903,
        },
      },
      place_id: 'ChIJBYDLpPfEYpYR906xHC-Kpd4',
    },
    'Gran Torre Santiago': {
      adr_address: '<span class="street-address">Gran Torre Santiago</span>, <span class="locality">Providencia</span>, <span class="region">Región Metropolitana</span>, <span class="country-name">Chile</span>',
      formatted_address: 'Gran Torre Santiago, Providencia, Región Metropolitana, Chile',
      geometry: {
        location: {
          lat: -33.416889,
          lng: -70.606706,
        },
      },
      place_id: 'ChIJC3bz0mnPYpYR7cnMlUfZEs4',
    },
    'Palacio de La Moneda': {
      adr_address: '<span class="street-address">Palacio de La Moneda</span>, <span class="locality">Santiago</span>, <span class="region">Región Metropolitana</span>, <span class="country-name">Chile</span>',
      formatted_address: 'Palacio de La Moneda, Santiago, Región Metropolitana, Chile',
      geometry: {
        location: {
          lat: -33.4429091,
          lng: -70.6538699,
        },
      },
      place_id: 'ChIJZeRH_abFYpYRgq6ITSuhD10',
    },
    'Parque Metropolitano': {
      adr_address: '<span class="street-address">Parque Metropolitano</span>, <span class="locality">Providencia</span>, <span class="region">Región Metropolitana</span>, <span class="country-name">Chile</span>',
      formatted_address: 'Parque Metropolitano, Providencia, Región Metropolitana, Chile',
      geometry: {
        location: {
          lat: -33.4169033,
          lng: -70.6190958,
        },
      },
      place_id: 'ChIJ165eV5DFYpYRClPKuH_c8sw',
    },
    'Parque O\'Higgins': {
      adr_address: '<span class="street-address">Parque O&#39;Higgins</span>, <span class="locality">Santiago</span>, <span class="region">Región Metropolitana</span>, <span class="country-name">Chile</span>',
      formatted_address: "Parque O'Higgins, Santiago, Región Metropolitana, Chile",
      geometry: {
        location: {
          lat: -33.4625076,
          lng: -70.65745369999999,
        },
      },
      place_id: 'EjhQYXJxdWUgTydIaWdnaW5zLCBTYW50aWFnbywgUmVnacOzbiBNZXRyb3BvbGl0YW5hLCBDaGlsZSIuKiwKFAoSCX0o5y8bxWKWEWEgjF-HaYqXEhQKEgm7OvKaBtBilhGXSO0J9Fmdhw',
    },
    'Plaza de Armas': {
      adr_address: '<span class="street-address">Pl. de Armas</span>, <span class="locality">Santiago</span>, <span class="region">Región Metropolitana</span>, <span class="country-name">Chile</span>',
      formatted_address: 'Pl. de Armas, Santiago, Región Metropolitana, Chile',
      geometry: {
        location: {
          lat: -33.4378433,
          lng: -70.65047779999999,
        },
      },
      place_id: 'ChIJB3OVkKPFYpYRx9e-5v-H7wA',
    },
  },

  //  REPÚBLICA DOMINICANA
  'santo-domingo': {
    'Aeropuerto Internacional de Santo Domingo Norte (AISDN)': {
      adr_address: 'H2G9+76G, <span class="street-address">Aeropuerto Internacional La Isabela</span>, <span class="locality">Santo Domingo</span>, <span class="country-name">República Dominicana</span>',
      formatted_address: 'Aeropuerto Internacional La Isabela, Santo Domingo, República Dominicana',
      geometry: {
        location: {
          lat: 18.5756933,
          lng: -69.9819191,
        },
      },
      place_id: 'ChIJefBEPzONr44Rvn4JTGgZGak',
    },
    'Aeropuerto Internacional Las Américas': {
      adr_address: '<span class="street-address">Ruta 66 Salida Del Aeropuerto Las Americas</span>, <span class="locality">Santo Domingo</span> <span class="postal-code">11336</span>, <span class="country-name">República Dominicana</span>',
      formatted_address: 'Aeropuerto Las Americas, Santo Domingo 11336, República Dominicana',
      geometry: {
        location: {
          lat: 18.4302189,
          lng: -69.67648539999999,
        },
      },
      place_id: 'ChIJAc--WP5_pY4RlxhC1JejMCM',
    },
    'Puerto Port Santo Domingo': {
      adr_address: 'F498+GJX, <span class="locality">Santo Domingo</span> <span class="postal-code">10210</span>, <span class="country-name">República Dominicana</span>',
      formatted_address: 'Port Santo Domingo, Santo Domingo 10210, República Dominicana',
      geometry: {
        location: {
          lat: 18.4688537,
          lng: -69.8833913,
        },
      },
      place_id: 'ChIJS4K1BxiIr44R1mhX5LaJnFk',
    },
    'Parque Cervantes': {
      adr_address: '<span class="street-address">C. José Gabriel García 309</span>, <span class="locality">Santo Domingo</span> <span class="postal-code">10210</span>, <span class="country-name">República Dominicana</span>',
      formatted_address: 'Parque Cervantes, Santo Domingo 10210, República Dominicana',
      geometry: {
        location: {
          lat: 18.467375,
          lng: -69.8905037,
        },
      },
      place_id: 'ChIJQehvYiSIr44RFxd5c69bGGM',
    },
    'Zona Colonial': {
      adr_address: 'F4F8+696, <span class="street-address">Callejón de los Curas</span>, <span class="locality">Santo Domingo</span> <span class="postal-code">10210</span>, <span class="country-name">República Dominicana</span>',
      formatted_address: 'F4F8+696, Callejón de los Curas, Santo Domingo 10210, República Dominicana',
      geometry: {
        location: {
          lat: 18.4730298,
          lng: -69.8841036,
        },
      },
      place_id: 'ChIJh4KBhj2Ir44RNOjwG4qFZFk',
    },
    'El Malecón': {
      adr_address: '<span class="street-address">Av. George Washington esq</span>, <span class="locality">Santo Domingo</span>, <span class="country-name">República Dominicana</span>',
      formatted_address: 'Av. George Washington esq, Santo Domingo, República Dominicana',
      geometry: {
        location: {
          lat: 18.4549196,
          lng: -69.9170599,
        },
      },
      place_id: 'ChIJ8caoOXpipY4RH7UjThgSszU',
    },
    'Palacio Nacional de la República Dominicana': {
      adr_address: '<span class="street-address">Av. México</span>, <span class="locality">Santo Domingo</span>, <span class="country-name">República Dominicana</span>',
      formatted_address: 'Av. México, Santo Domingo, República Dominicana',
      geometry: {
        location: {
          lat: 18.47452939999999,
          lng: -69.8977646,
        },
      },
      place_id: 'ChIJEetJ5TCIr44RiGcF_o35EGg',
    },
  },

  //  ECUADOR
  guayaquil: {
    'Parque Histórico Guayaquil': {
      adr_address: '<span class="street-address">Parque Histórico Guayaquil</span>, <span class="locality">Samborondón</span> <span class="postal-code">092301</span>, <span class="country-name">Ecuador</span>',
      formatted_address: 'Parque Histórico Guayaquil, Samborondón 092301, Ecuador',
      geometry: {
        location: {
          lat: -2.1441876,
          lng: -79.8687557,
        },
      },
      place_id: 'ChIJDX04I_xsLZARkS5V-WM3h2s',
    },
    'Malecón 2000': {
      adr_address: '<span class="street-address">Malecón 2000</span>, <span class="locality">Guayaquil</span> <span class="postal-code">090313</span>, <span class="country-name">Ecuador</span>',
      formatted_address: 'Malecón 2000, Guayaquil 090313, Ecuador',
      geometry: {
        location: {
          lat: -2.1917649,
          lng: -79.8794617,
        },
      },
      place_id: 'ChIJv14KwGRuLZARu47gNAE_mAs',
    },
    'Cerro Santa Ana': {
      adr_address: 'Cerro Santa Ana, <span class="locality">Guayaquil</span> <span class="postal-code">090313</span>, <span class="country-name">Ecuador</span>',
      formatted_address: 'Cerro Santa Ana, Guayaquil 090313, Ecuador',
      geometry: {
        location: {
          lat: -2.1795812,
          lng: -79.8811557,
        },
      },
      place_id: 'ChIJY7J44dFtLZARehrv8DNAowc',
    },
    'Parque Seminario/Parque de las Iguanas': {
      adr_address: '<span class="street-address">Chimborazo</span>, <span class="locality">Guayaquil</span> <span class="postal-code">090313</span>, <span class="country-name">Ecuador</span>',
      formatted_address: 'Chimborazo, Guayaquil 090313, Ecuador',
      geometry: {
        location: {
          lat: -2.1946854,
          lng: -79.88309509999999,
        },
      },
      place_id: 'ChIJF-l_MXpuLZARyfVqu_mL4Ek',
    },
    'Terminal Terrestre de Guayaquil': {
      adr_address: '<span class="street-address">Av. de las Américas</span>, <span class="locality">Guayaquil</span> <span class="postal-code">090513</span>, <span class="country-name">Ecuador</span>',
      formatted_address: 'Av. de las Américas, Guayaquil 090513, Ecuador',
      geometry: {
        location: {
          lat: -2.1431673,
          lng: -79.8794521,
        },
      },
      place_id: 'ChIJITEFYwRtLZAR5Pmfh-3EuGk',
    },
    'Aeropuerto Internacional José Joaquín de Olmedo': {
      adr_address: 'V428+P7G, <span class="street-address">Av. de las Américas</span>, <span class="locality">Guayaquil</span> <span class="postal-code">090513</span>, <span class="country-name">Ecuador</span>',
      formatted_address: 'V428+P7G, Av. de las Américas, Guayaquil 090513, Ecuador',
      geometry: {
        location: {
          lat: -2.1481931,
          lng: -79.88430989999999,
        },
      },
      place_id: 'ChIJ7xJtJr9tLZARE0ZZaR5tdyo',
    },
    'Parque Centenario': {
      adr_address: '<span class="street-address">Pedro Moncayo &amp;</span>, <span class="locality">Guayaquil</span> <span class="postal-code">090312</span>, <span class="country-name">Ecuador</span>',
      formatted_address: 'Pedro Moncayo &, Guayaquil 090312, Ecuador',
      geometry: {
        location: {
          lat: -2.1898316,
          lng: -79.8876482,
        },
      },
      place_id: 'ChIJFSJlz3duLZAROeEdXwG1rLI',
    },
    'Estadio Monumental Banco Pichincha': {
      adr_address: '<span class="street-address">Av. Barcelona</span>, <span class="locality">Guayaquil</span> <span class="postal-code">090615</span>, <span class="country-name">Ecuador</span>',
      formatted_address: 'Av. Barcelona, Guayaquil 090615, Ecuador',
      geometry: {
        location: {
          lat: -2.1858844,
          lng: -79.925253,
        },
      },
      place_id: 'ChIJOVz1KuBtLZAR9r3tJjGWz3A',
    },
    'Parque Samanes': {
      adr_address: 'Alameda 3 NESamanes 7, <span class="locality">Guayaquil</span> <span class="postal-code">090112</span>, <span class="country-name">Ecuador</span>',
      formatted_address: 'Alameda 3 NESamanes 7, Guayaquil 090112, Ecuador',
      geometry: {
        location: {
          lat: -2.1037646,
          lng: -79.89916989999999,
        },
      },
      place_id: 'ChIJ02BXpLcSLZARg5AoCYWDZYw',
    },
  },
  quito: {
    'Centro Histórico de Quito': {
      adr_address: 'Centro Histórico, <span class="locality">Quito</span>, <span class="country-name">Ecuador</span>',
      formatted_address: 'Centro Histórico, Quito, Ecuador',
      geometry: {
        location: {
          lat: -0.2188216,
          lng: -78.5135489,
        },
      },
      place_id: 'ChIJDepmtSma1ZERTTe1KXMH4_4',
    },
    'Mitad del Mundo': {
      adr_address: '<span class="street-address">Av. Manuel Córdova Galarza SN</span>, <span class="locality">Quito</span>, <span class="country-name">Ecuador</span>',
      formatted_address: 'Av. Manuel Córdova Galarza SN, Quito, Ecuador',
      geometry: {
        location: {
          lat: -0.002147399999999999,
          lng: -78.45583239999999,
        },
      },
      place_id: 'ChIJka2b-B6I1ZERuKmhAJtp4bI',
    },
    'Terminal Terrestre Carcelén - Norte': {
      adr_address: 'VGXH+WR9, <span class="street-address">Av. Eloy Alfaro</span>, <span class="locality">Quito</span> <span class="postal-code">170144</span>, <span class="country-name">Ecuador</span>',
      formatted_address: 'VGXH+WR9, Av. Eloy Alfaro, Quito 170144, Ecuador',
      geometry: {
        location: {
          lat: -0.1001528,
          lng: -78.4699705,
        },
      },
      place_id: 'ChIJa1TiOBCP1ZERLW_WWXh0EUE',
    },
    'Terminal Terrestre Quitumbe - Sur': {
      adr_address: '<span class="street-address">Av. Mariscal Sucre 2756</span>, <span class="locality">Quito</span> <span class="postal-code">170146</span>, <span class="country-name">Ecuador</span>',
      formatted_address: 'Av. Mariscal Sucre 2756, Quito 170146, Ecuador',
      geometry: {
        location: {
          lat: -0.2963745,
          lng: -78.5566416,
        },
      },
      place_id: 'ChIJERR0qwei1ZER3ptctnzdvjE',
    },
    'Plaza Foch': {
      adr_address: 'Plaza Foch, <span class="locality">Quito</span> <span class="postal-code">170143</span>, <span class="country-name">Ecuador</span>',
      formatted_address: 'Plaza Foch, Quito 170143, Ecuador',
      geometry: {
        location: {
          lat: -0.2029384,
          lng: -78.4910884,
        },
      },
      place_id: 'ChIJfym8axOa1ZER8vc-vyt_Sdw',
    },
    'Mercado Artesanal La Mariscal': {
      adr_address: '<span class="street-address">Jorge Washington 611</span>, <span class="locality">Quito</span> <span class="postal-code">170143</span>, <span class="country-name">Ecuador</span>',
      formatted_address: 'Jorge Washington 611, Quito 170143, Ecuador',
      geometry: {
        location: {
          lat: -0.2070687,
          lng: -78.4951281,
        },
      },
      place_id: 'ChIJAWxzYhaa1ZERTN5JZ7en3IQ',
    },
    'Aeropuerto Internacional Mariscal Sucre': {
      adr_address: 'Tababela Parish S/N via Yaruquí, <span class="locality">Quito</span> <span class="postal-code">170183</span>, <span class="country-name">Ecuador</span>',
      formatted_address: 'Tababela Parish S/N via Yaruquí, Quito 170183, Ecuador',
      geometry: {
        location: {
          lat: -0.1242271,
          lng: -78.36056839999999,
        },
      },
      place_id: 'ChIJh6orNbSN1ZERi0uJ4CN2ny8',
    },
    'Barrio La Floresta': {
      adr_address: 'La Floresta, <span class="locality">Quito</span>, <span class="country-name">Ecuador</span>',
      formatted_address: 'La Floresta, Quito, Ecuador',
      geometry: {
        location: {
          lat: -0.2089362,
          lng: -78.4852403,
        },
      },
      place_id: 'ChIJD1UmCI2F1ZERHqQTTlIVXHA',
    },
    'Plaza Grande': {
      adr_address: 'Plaza Grande, <span class="locality">Quito</span> <span class="postal-code">170401</span>, <span class="country-name">Ecuador</span>',
      formatted_address: 'Plaza Grande, Quito 170401, Ecuador',
      geometry: {
        location: {
          lat: -0.220124,
          lng: -78.512081,
        },
      },
      place_id: 'ChIJDxkPgoeZ1ZERXqNMH562TCk',
    },
  },

  //  COSTA RICA
  'san-jose': {
    'Aeropuerto Internacional Juan Santamaría': {
      adr_address: 'XQXW+43V, <span class="region">Provincia de Alajuela</span>, <span class="locality">Alajuela</span>, <span class="country-name">Costa Rica</span>',
      formatted_address: 'Aeropuerto Internacional Juan Santamaría, Alajuela, Costa Rica',
      geometry: {
        location: {
          lat: 9.997866899999998,
          lng: -84.2048202,
        },
      },
      place_id: 'ChIJc3hQUMT5oI8RpDE_DiJie7I',
    },
    'Catedral Metropolitana de San José': {
      adr_address: 'Calle Central, Avenida Segunda, <span class="street-address">Av. 2</span>, <span class="region">Catedral, San José Province</span>, <span class="locality">San José</span>, <span class="country-name">Costa Rica</span>',
      formatted_address: 'Calle Central, Avenida Segunda, Av. 2, Catedral, San José Province, San José, Costa Rica',
      geometry: {
        location: {
          lat: 9.932589799999999,
          lng: -84.07868599999999,
        },
      },
      place_id: 'ChIJA60XOGfjoI8R1tuVyR_KcZs',
    },
    'Parque Zoológico y Jardín Botánico Nacional Simón Bolívar': {
      adr_address: 'Parque Zoológico y Jardín Botánico Nacional Simón Bolívar, <span class="region">Amón, San José</span>, <span class="postal-code">10101</span>, <span class="country-name">Costa Rica</span>',
      formatted_address: 'Parque Zoológico y Jardín Botánico Nacional Simón Bolívar, Amón, San José, 10101, Costa Rica',
      geometry: {
        location: {
          lat: 9.938637,
          lng: -84.07328000000001,
        },
      },
      place_id: 'ChIJj-CxgJ3koI8RUkhC56QHB6U',
    },
    'Mercado Central de San José': {
      adr_address: 'Mercado central de San José, <span class="street-address">Av. Central</span>, <span class="region">Paso De La Vaca, San José</span>, <span class="country-name">Costa Rica</span>',
      formatted_address: 'Mercado central de San José, Av. Central, Paso De La Vaca, San José, Costa Rica',
      geometry: {
        location: {
          lat: 9.9347694,
          lng: -84.08193759999999,
        },
      },
      place_id: 'ChIJb_JaaF7joI8R213-_Xs-KLA',
    },
    'Estación de Ferrocarril al Atlántico': {
      adr_address: '<span class="street-address">Av. 3</span>, <span class="region">Aranjuez, San José</span>, <span class="postal-code">10101</span>, <span class="country-name">Costa Rica</span>',
      formatted_address: 'Av. 3, Aranjuez, San José, 10101, Costa Rica',
      geometry: {
        location: {
          lat: 9.934709999999999,
          lng: -84.06884459999999,
        },
      },
      place_id: 'ChIJC_zsznzjoI8Rtu9Kzvvw2HU',
    },
    'Parque Metropolitano La Sabana': {
      adr_address: 'WVPW+8HH, <span class="street-address">Av. de Las Américas</span>, <span class="region">Sabana, San José</span>, <span class="country-name">Costa Rica</span>',
      formatted_address: 'WVPW+8HH, Av. de Las Américas, Sabana, San José, Costa Rica',
      geometry: {
        location: {
          lat: 9.9358085,
          lng: -84.10350150000001,
        },
      },
      place_id: 'ChIJM_Dtpqv8oI8RyETi6jXqf_c',
    },
    'Parque Central': {
      adr_address: 'Parque Central, <span class="street-address">C. Central Alfredo Volio</span>, <span class="region">Merced, San José</span>, <span class="country-name">Costa Rica</span>',
      formatted_address: 'Parque Central, C. Central Alfredo Volio, Merced, San José, Costa Rica',
      geometry: {
        location: {
          lat: 9.932875099999999,
          lng: -84.0798276,
        },
      },
      place_id: 'ChIJV1hlUGfjoI8R5a0O7nFPD4s',
    },
  },

  //  PERÚ
  lima: {
    Larcomar: {
      adr_address: '<span class="street-address">Mal. de la Reserva 610</span>, <span class="locality">Miraflores</span> <span class="postal-code">15074</span>, <span class="country-name">Perú</span>',
      formatted_address: 'Mal. de la Reserva 610, Miraflores 15074, Perú',
      geometry: {
        location: {
          lat: -12.1319502,
          lng: -77.0305149,
        },
      },
      place_id: 'ChIJM6W1tOG3BZERGPvcJjIESaU',
    },
    Miraflores: {
      adr_address: 'Miraflores, <span class="country-name">Perú</span>',
      formatted_address: 'Miraflores, Perú',
      geometry: {
        location: {
          lat: -12.1218773,
          lng: -77.03053899999999,
        },
      },
      place_id: 'ChIJJTSjnhnIBZERahU6nG5i478',
    },
    Barranco: {
      adr_address: '<span class="locality">Barranco</span>, <span class="country-name">Perú</span>',
      formatted_address: 'Barranco, Perú',
      geometry: {
        location: {
          lat: -12.1411508,
          lng: -77.0221186,
        },
      },
      place_id: 'ChIJsUpGGeS3BZERGWmKE_bmWws',
    },
    'San Isidro': {
      adr_address: 'San Isidro, <span class="country-name">Perú</span>',
      formatted_address: 'San Isidro, Perú',
      geometry: {
        location: {
          lat: -12.0997587,
          lng: -77.0362967,
        },
      },
      place_id: 'ChIJ-0IjvULIBZERBxJGX_SDMX4',
    },
    'Plaza Mayor de Lima': {
      adr_address: 'Plaza central Lima, <span class="locality">Lima</span> <span class="postal-code">15001</span>, <span class="country-name">Perú</span>',
      formatted_address: 'Plaza central Lima, Lima 15001, Perú',
      geometry: {
        location: {
          lat: -12.0460038,
          lng: -77.0305458,
        },
      },
      place_id: 'ChIJsX6q1bXIBZERqiIeSAseBhY',
    },
    'Centro Histórico Lima': {
      adr_address: 'Centro Histórico, <span class="locality">Lima</span> <span class="postal-code">15001</span>, <span class="country-name">Perú</span>',
      formatted_address: 'Centro Histórico, Lima 15001, Perú',
      geometry: {
        location: {
          lat: -12.0477954,
          lng: -77.0319784,
        },
      },
      place_id: 'ChIJkzeqdLbIBZERzolWqH64Kc4',
    },
    'Aeropuerto Internacional Jorge Chávez': {
      adr_address: '<span class="street-address">Av. Elmer Faucett s/n</span>, <span class="locality">Callao</span> <span class="postal-code">07031</span>, <span class="country-name">Perú</span>',
      formatted_address: 'Av. Elmer Faucett s/n, Callao 07031, Perú',
      geometry: {
        location: {
          lat: -12.0230437,
          lng: -77.10799759999999,
        },
      },
      place_id: 'ChIJAR71Uj3MBZERLGUS-5eudR8',
    },
  },
  cusco: {
    'Aeropuerto Internacional Teniente Alejandro Velasco Astete': {
      geometry: {
        location: {
          lat: -13.5383906,
          lng: -71.94316289999999,
        },
      },
      formatted_address: 'Aeropuerto Internacional, Av. Velasco Astete, Cusco 08006, Perú',
    },
    'Centro Histórico Cusco': {
      adr_address: 'Centro Histórico, <span class="locality">Cusco</span>, <span class="country-name">Perú</span>',
      formatted_address: 'Centro Histórico, Cusco, Perú',
      geometry: {
        location: {
          lat: -13.52021,
          lng: -71.97866259999999,
        },
      },
      place_id: 'ChIJCWXy8nPWbZERaGM_2uVULao',
    },
    'Plaza Mayor De Cuzco': {
      adr_address: '<span class="street-address">Del Medio 123</span>, <span class="locality">Cusco</span> <span class="postal-code">08000</span>, <span class="country-name">Perú</span>',
      formatted_address: 'Del Medio 123, Cusco 08000, Perú',
      geometry: {
        location: {
          lat: -13.516772,
          lng: -71.9787231,
        },
      },
      place_id: 'ChIJdfHXnHPWbZERQ2P8gpCafAI',
    },
    'Plazoleta de San Blas': {
      adr_address: '<span class="street-address">Plazoleta de San Blas</span>, <span class="locality">Cusco</span> <span class="postal-code">08003</span>, <span class="country-name">Perú</span>',
      formatted_address: 'Plazoleta de San Blas, Cusco 08003, Perú',
      geometry: {
        location: {
          lat: -13.5150664,
          lng: -71.9743089,
        },
      },
      place_id: 'EihQbGF6b2xldGEgZGUgU2FuIEJsYXMsIEN1c2NvIDA4MDAzLCBQZXJ1Ii4qLAoUChIJ5xOEwgzWbZERXblC_srJCcgSFAoSCTGEWSbY1W2REV0xGCPMlqkq',
    },
    'Sacsayhuamán ': {
      adr_address: 'Sacsayhuamán, <span class="country-name">Perú</span>',
      formatted_address: 'Sacsayhuamán, Perú',
      geometry: {
        location: {
          lat: -13.5050343,
          lng: -71.98014429999999,
        },
      },
      place_id: 'ChIJOarrDmzWbZER9mEPKaBHR2I',
    },
    'Mercado Central de San Pedro': {
      adr_address: '<span class="street-address">Thupaq Amaru 477</span>, <span class="locality">Cusco</span> <span class="postal-code">08002</span>, <span class="country-name">Perú</span>',
      formatted_address: 'Thupaq Amaru 477, Cusco 08002, Perú',
      geometry: {
        location: {
          lat: -13.5209577,
          lng: -71.9826676,
        },
      },
      place_id: 'ChIJaWY1ZHbWbZERoIWkJG4X0WY',
    },
    'Catedral del Cuzco': {
      adr_address: '<span class="locality">Cusco</span> <span class="postal-code">08002</span>, <span class="country-name">Perú</span>',
      formatted_address: 'Cusco 08002, Perú',
      geometry: {
        location: {
          lat: -13.5161895,
          lng: -71.9778728,
        },
      },
      place_id: 'ChIJl9eabXPWbZERaUOxoJ0PlfU',
    },
  },

  //  PANAMÁ
  panama: {
    'Casco Antiguo Panamá': {
      adr_address: 'San Felipe, <span class="locality">Panamá</span>',
      formatted_address: 'San Felipe, Panamá',
      geometry: {
        location: {
          lat: 8.9531326,
          lng: -79.5357556,
        },
      },
      place_id: 'ChIJDdtX0DSvrI8R0DyXDA4C-Mg',
    },
    'Aeropuerto Internacional de Tocumen': {
      adr_address: '<span class="street-address">Av. Domingo Díaz</span>, <span class="locality">Panamá</span>',
      formatted_address: 'Av. Domingo Díaz, Panamá',
      geometry: {
        location: {
          lat: 9.067049899999999,
          lng: -79.38746019999999,
        },
      },
      place_id: 'ChIJX5DCdTFVq48ResLbkE0qxJc',
    },
    'Museo de Panamá Viejo': {
      adr_address: '2G34+FJ7, <span class="street-address">Av. Cincuentenario</span>, <span class="locality">Panamá</span>',
      formatted_address: '2G34+FJ7, Av. Cincuentenario, Panamá',
      geometry: {
        location: {
          lat: 9.0036734,
          lng: -79.4934621,
        },
      },
      place_id: 'ChIJY-wQmqKprI8Ry_UD9BEc7Do',
    },
    'Terminal de Transporte de Albrook': {
      adr_address: 'XCFX+M7P, <span class="street-address">Avenida Roosevelt</span>, <span class="locality">Panama City</span>, <span class="country-name">Panamá</span>',
      formatted_address: 'XCFX+M7P, Avenida Roosevelt, Panama City, Panamá',
      geometry: {
        location: {
          lat: 8.9742079,
          lng: -79.5518112,
        },
      },
      place_id: 'ChIJS4cEu6OorI8RZ9bhWhmTe7g',
    },
    'Canal de Panamá - Miraflores': {
      adr_address: 'XCW5+WF2, <span class="locality">Panamá</span>',
      formatted_address: 'XCW5+WF2, Panamá',
      geometry: {
        location: {
          lat: 8.9972715,
          lng: -79.5913604,
        },
      },
      place_id: 'ChIJZ0w5Lk2mrI8RRkUdX6_3je4',
    },
    'Iglesia Nuestra Señora Del Carmen': {
      adr_address: 'XFJC+JM3, <span class="street-address">Av. Manuel Espinosa Batista</span>, <span class="locality">Panamá</span>',
      formatted_address: 'XFJC+JM3, Av. Manuel Espinosa Batista, Panamá',
      geometry: {
        location: {
          lat: 8.981507200000001,
          lng: -79.52833210000001,
        },
      },
      place_id: 'ChIJf6vxEu-orI8RoqZi7BlxQM4',
    },
    Biomuseo: {
      adr_address: '<span class="street-address">Calz. de Amador 136</span>, <span class="locality">Panamá</span>',
      formatted_address: 'Calz. de Amador 136, Panamá',
      geometry: {
        location: {
          lat: 8.9322213,
          lng: -79.5446353,
        },
      },
      place_id: 'ChIJva9mbEKvrI8Ru8pepGP3xkQ',
    },
    'Monumento de La Bandera de Panamá': {
      adr_address: 'XF58+2RV, <span class="locality">Panamá</span>',
      formatted_address: 'XF58+2RV, Panamá',
      geometry: {
        location: {
          lat: 8.9576019,
          lng: -79.5329378,
        },
      },
      place_id: 'ChIJQWTN_MuorI8RrZVIrCxKuPM',
    },
  },

  //  BRASIL
  'sao-paulo': {
    'Aeropuerto Internacional de São Paulo-Guarulhos': {
      adr_address: '<span class="street-address">Rod. Hélio Smidt, s/nº</span> - <span class="extended-address">Aeroporto</span>, <span class="locality">Guarulhos</span> - <span class="region">SP</span>, <span class="postal-code">07190-100</span>, <span class="country-name">Brasil</span>',
      formatted_address: 'Rod. Hélio Smidt, s/nº - Aeroporto, Guarulhos - SP, 07190-100, Brasil',
      geometry: {
        location: {
          lat: -23.42623429999999,
          lng: -46.48000769999999,
        },
      },
      place_id: 'ChIJJSpyb_mKzpQRShWnUWxicYA',
    },
    'Catedral Metropolitana de São Paulo': {
      adr_address: '<span class="street-address">Praça da Sé</span> - <span class="extended-address">Sé</span>, <span class="locality">São Paulo</span> - <span class="region">SP</span>, <span class="postal-code">01001-000</span>, <span class="country-name">Brasil</span>',
      formatted_address: 'Praça da Sé - Sé, São Paulo - SP, 01001-000, Brasil',
      geometry: {
        location: {
          lat: -23.5512802,
          lng: -46.6343427,
        },
      },
      place_id: 'ChIJ8e6ysqtZzpQR9QNBpGcus_0',
    },
    'Praça da República': {
      adr_address: '<span class="street-address">Praça da República</span> - <span class="extended-address">República</span>, <span class="locality">São Paulo</span> - <span class="region">SP</span>, <span class="postal-code">14786-079</span>, <span class="country-name">Brasil</span>',
      formatted_address: 'Praça da República - República, São Paulo - SP, 14786-079, Brasil',
      geometry: {
        location: {
          lat: -23.5440722,
          lng: -46.6425062,
        },
      },
      place_id: 'EkVQcmHDp2EgZGEgUmVww7pibGljYSAtIFJlcMO6YmxpY2EsIFPDo28gUGF1bG8gLSBTUCwgMTQ3ODYtMDc5LCBCcmF6aWwiLiosChQKEgkx9VG2T1jOlBHALW_67g5svBIUChIJO185wFFYzpQRAvOPf6qlbvM',
    },
    Pinheiros: {
      adr_address: '<span class="extended-address">Pinheiros</span>, <span class="locality">São Paulo</span> - <span class="region">State of São Paulo</span>, <span class="country-name">Brasil</span>',
      formatted_address: 'Pinheiros, São Paulo - State of São Paulo, Brasil',
      geometry: {
        location: {
          lat: -23.5635787,
          lng: -46.6916068,
        },
      },
      place_id: 'ChIJjyYWy5hXzpQRCDea46MUQKk',
    },
    Jardins: {
      adr_address: '<span class="extended-address">Jardins</span>, <span class="locality">São Paulo</span> - <span class="region">Estado de São Paulo</span>, <span class="country-name">Brasil</span>',
      formatted_address: 'Jardins, São Paulo - Estado de São Paulo, Brasil',
      geometry: {
        location: {
          lat: -23.5734145,
          lng: -46.67294829999999,
        },
      },
      place_id: 'ChIJ-dNk-XhXzpQRLGa92Yb2eLQ',
    },
    'Bairro Itaim Bibi': {
      adr_address: '<span class="extended-address">Bairro Itaim Bibi</span>, <span class="locality">São Paulo</span> - <span class="region">Estado de São Paulo</span>, <span class="country-name">Brasil</span>',
      formatted_address: 'Bairro Itaim Bibi, São Paulo - Estado de São Paulo, Brasil',
      geometry: {
        location: {
          lat: -23.5837476,
          lng: -46.6780743,
        },
      },
      place_id: 'ChIJKSqDvEJXzpQR22Q4QxM_Mqk',
    },
    'Vila Madalena': {
      adr_address: '<span class="extended-address">Vila Madalena</span>, <span class="locality">São Paulo</span> - <span class="region">State of São Paulo</span>, <span class="country-name">Brasil</span>',
      formatted_address: 'Vila Madalena, São Paulo - State of São Paulo, Brasil',
      geometry: {
        location: {
          lat: -23.5514369,
          lng: -46.6975656,
        },
      },
      place_id: 'ChIJqX-Eab5XzpQRAR6d3ZfRI9Q',
    },
    'Bela Vista': {
      adr_address: '<span class="extended-address">Bela Vista</span>, <span class="locality">São Paulo</span> - <span class="region">State of São Paulo</span>, <span class="country-name">Brasil</span>',
      formatted_address: 'Bela Vista, São Paulo - State of São Paulo, Brasil',
      geometry: {
        location: {
          lat: -23.5554048,
          lng: -46.6456426,
        },
      },
      place_id: 'ChIJYT1GVrdZzpQRZAn09-bR8wk',
    },
    Consolação: {
      adr_address: '<span class="extended-address">Consolação</span>, <span class="locality">São Paulo</span> - <span class="region">State of São Paulo</span>, <span class="country-name">Brasil</span>',
      formatted_address: 'Consolação, São Paulo - State of São Paulo, Brasil',
      geometry: {
        location: {
          lat: -23.5520577,
          lng: -46.6525766,
        },
      },
      place_id: 'ChIJLbKsqspZzpQRflMUqtJkSPE',
    },
    'Mercado Municipal de São Paulo': {
      adr_address: '<span class="street-address">R. da Cantareira, 306</span> - <span class="extended-address">Centro Histórico de São Paulo</span>, <span class="locality">São Paulo</span> - <span class="region">SP</span>, <span class="postal-code">01024-900</span>, <span class="country-name">Brasil</span>',
      formatted_address: 'R. da Cantareira, 306 - Centro Histórico de São Paulo, São Paulo - SP, 01024-900, Brasil',
      geometry: {
        location: {
          lat: -23.5417538,
          lng: -46.6300817,
        },
      },
      place_id: 'ChIJBQICYYxfzpQR9P4GxnTkmgA',
    },
    'Museu do Futebol': {
      adr_address: '<span class="street-address">Praça Charles Miller, s/n</span> - <span class="extended-address">Pacaembu</span>, <span class="locality">São Paulo</span> - <span class="region">SP</span>, <span class="postal-code">01234-010</span>, <span class="country-name">Brasil</span>',
      formatted_address: 'Praça Charles Miller, s/n - Pacaembu, São Paulo - SP, 01234-010, Brasil',
      geometry: {
        location: {
          lat: -23.54769199999999,
          lng: -46.66513639999999,
        },
      },
      place_id: 'ChIJf7Cs2iVYzpQRzp6ZfOjJ3s8',
    },
    'Av. Paulista': {
      adr_address: '<span class="street-address">Av. Paulista</span> - <span class="extended-address">Bela Vista</span>, <span class="locality">São Paulo</span> - <span class="region">SP</span>, <span class="country-name">Brasil</span>',
      formatted_address: 'Av. Paulista - Bela Vista, São Paulo - SP, Brasil',
      geometry: {
        location: {
          lat: -23.5657393,
          lng: -46.6512379,
        },
      },
      place_id: 'EjJBdi4gUGF1bGlzdGEgLSBCZWxhIFZpc3RhLCBTw6NvIFBhdWxvIC0gU1AsIEJyYXppbCIuKiwKFAoSCRWjCtrIWc6UEWp3yfIxlJ_VEhQKEglhPUZWt1nOlBFkCfT35tHzCQ',

    },
  },
  'rio-de-janeiro': {
    'Aeropuerto Internacional de Galeão': {
      adr_address: '<span class="street-address">Av. Vinte de Janeiro, s/nº</span> - <span class="extended-address">Ilha do Governador</span>, <span class="locality">Rio de Janeiro</span> - <span class="region">RJ</span>, <span class="postal-code">21941-900</span>, <span class="country-name">Brasil</span>',
      formatted_address: 'Av. Vinte de Janeiro, s/nº - Ilha do Governador, Rio de Janeiro - RJ, 21941-900, Brasil',
      geometry: {
        location: {
          lat: -22.805265,
          lng: -43.25662930000001,
        },
      },
      place_id: 'ChIJTzYWO495mQAREkVYL7_fqc8',
    },
    'Aeropuerto Santos Dumont': {
      adr_address: '<span class="street-address">Praça Sen. Salgado Filho, s/n</span> - <span class="extended-address">Centro</span>, <span class="locality">Rio de Janeiro</span> - <span class="region">RJ</span>, <span class="postal-code">20021-340</span>, <span class="country-name">Brasil</span>',
      formatted_address: 'Praça Sen. Salgado Filho, s/n - Centro, Rio de Janeiro - RJ, 20021-340, Brasil',
      geometry: {
        location: {
          lat: -22.9109516,
          lng: -43.1669826,
        },
      },
      place_id: 'ChIJe-vdndyBmQARx9w1PRRi3eU',
    },
    'Estação Central do Brasil': {
      adr_address: '<span class="street-address">Praça Cristiano Ottoni, S/N</span> - <span class="extended-address">Centro</span>, <span class="locality">Rio de Janeiro</span> - <span class="region">RJ</span>, <span class="postal-code">20080-102</span>, <span class="country-name">Brasil</span>',
      formatted_address: 'Praça Cristiano Ottoni, S/N - Centro, Rio de Janeiro - RJ, 20080-102, Brasil',
      geometry: {
        location: {
          lat: -22.90338999999999,
          lng: -43.19171,
        },
      },
      place_id: 'ChIJY6P392p_mQAR5AcsyGwm8MY',
    },
    'Cristo Redentor': {
      adr_address: '<span class="street-address">Parque Nacional da Tijuca</span> - <span class="extended-address">Alto da Boa Vista</span>, <span class="locality">Rio de Janeiro</span> - <span class="region">RJ</span>, <span class="postal-code">22261</span>, <span class="country-name">Brasil</span>',
      formatted_address: 'Parque Nacional da Tijuca - Alto da Boa Vista, Rio de Janeiro - RJ, 22261, Brasil',
      geometry: {
        location: {
          lat: -22.951916,
          lng: -43.2104872,
        },
      },
      place_id: 'ChIJP6FKmNV_mQAR3gKVAdeEyZ0',
    },
    Ipanema: {
      adr_address: '<span class="extended-address">Ipanema</span>, <span class="locality">Río de Janeiro</span> - <span class="region">Estado de Río de Janeiro</span>, <span class="country-name">Brasil</span>',
      formatted_address: 'Ipanema, Río de Janeiro - Estado de Río de Janeiro, Brasil',
      geometry: {
        location: {
          lat: -22.984667,
          lng: -43.1985932,
        },
      },
      place_id: 'ChIJkWFy_g_VmwARe6ZZnNoVArs',
    },
    Copacabana: {
      adr_address: '<span class="extended-address">Copacabana</span>, <span class="locality">Río de Janeiro</span> - <span class="region">Estado de Río de Janeiro</span>, <span class="country-name">Brasil</span>',
      formatted_address: 'Copacabana, Río de Janeiro - Estado de Río de Janeiro, Brasil',
      geometry: {
        location: {
          lat: -22.9694417,
          lng: -43.1868448,
        },
      },
      place_id: 'ChIJU5wP0iPVmwARDWteYzJhPGk',
    },
    Maracanã: {
      adr_address: '<span class="extended-address">Maracanã</span>, <span class="locality">Río de Janeiro</span> - <span class="region">Estado de Río de Janeiro</span>, <span class="country-name">Brasil</span>',
      formatted_address: 'Maracanã, Rio de Janeiro - Estado de Rio de Janeiro, Brasil',
      geometry: {
        location: {
          lat: -22.9123207,
          lng: -43.2265479,
        },
      },
      place_id: 'ChIJp0Xv_Ft-mQARF6dc98hKBDw',
    },
    Leblon: {
      adr_address: '<span class="extended-address">Leblon</span>, <span class="locality">Rio de Janeiro</span> - <span class="region">Estado de Río de Janeiro</span>, <span class="country-name">Brasil</span>',
      formatted_address: 'Leblon, Rio de Janeiro - Estado de Rio de Janeiro, Brasil',
      geometry: {
        location: {
          lat: -22.9843373,
          lng: -43.2231424,
        },
      },
      place_id: 'ChIJX6EUtLPVmwAR0oCkOLoQnNE',
    },
    'Catedral de Rio de Janeiro': {
      adr_address: 'Av. Chile, 245 - Centro - <span class="extended-address">Centro</span>, <span class="locality">Rio de Janeiro</span> - <span class="region">RJ</span>, <span class="postal-code">20031-170</span>, <span class="country-name">Brasil</span>',
      formatted_address: 'Av. Chile, 245 - Centro - Centro, Rio de Janeiro - RJ, 20031-170, Brasil',
      geometry: {
        location: {
          lat: -22.9106741,
          lng: -43.180777,
        },
      },
      place_id: 'ChIJaXW-F2R_mQARjtqcwUcZSfM',
    },
  },

  //  ESPAÑA
  barcelona: {
    'Aeropuerto Josep Tarradellas': {
      adr_address: '<span class="postal-code">08820</span> <span class="locality">El Prat de Llobregat</span>, <span class="region">Barcelona</span>, <span class="country-name">España</span>',
      formatted_address: '08820 El Prat de Llobregat, Barcelona, España',
      geometry: {
        location: {
          lat: 41.2980327,
          lng: 2.0799026,
        },
      },
      place_id: 'ChIJpY58hGSepBIR15tv-0LpK_M',
    },
    'Arco de Triunfo': {
      adr_address: '<span class="street-address">Passeig de Lluís Companys</span>, <span class="region">Ciutat Vella</span>, <span class="postal-code">08003</span> <span class="locality">Barcelona</span>, <span class="country-name">España</span>',
      formatted_address: 'Passeig de Lluís Companys, Ciutat Vella, 08003 Barcelona, España',
      geometry: {
        location: {
          lat: 41.3910524,
          lng: 2.1806449,
        },
      },
      place_id: 'ChIJoXZqNuOipBIRsZU39a8r_qk',
    },
    'Barcelona-Sants': {
      adr_address: '<span class="street-address">Pl. dels Països Catalans, 1</span>, 7, <span class="region">Sants-Montjuïc</span>, <span class="postal-code">08014</span> <span class="locality">Barcelona</span>, <span class="country-name">España</span>',
      formatted_address: 'Pl. dels Països Catalans, 1, 7, Sants-Montjuïc, 08014 Barcelona, España',
      geometry: {
        location: {
          lat: 41.3789192,
          lng: 2.139889,
        },
      },
      place_id: 'ChIJOVbP1ICYpBIRjxcPpUQtfDo',
    },
    Barceloneta: {
      adr_address: 'La Barceloneta, <span class="region">Ciutat Vella</span>, <span class="locality">Barcelona</span>, <span class="country-name">España</span>',
      formatted_address: 'La Barceloneta, Ciutat Vella, Barcelona, España',
      geometry: {
        location: {
          lat: 41.3801061,
          lng: 2.1896957,
        },
      },
      place_id: 'ChIJk1xgCQejpBIRUvCCQOH6ACY',
    },
    'Barrio Gótico': {
      adr_address: 'Barri Gòtico, <span class="region">Ciutat Vella</span>, <span class="locality">Barcelona</span>, <span class="country-name">España</span>',
      formatted_address: 'Barri Gòtic, Ciutat Vella, Barcelona, España',
      geometry: {
        location: {
          lat: 41.3819247,
          lng: 2.1773052,
        },
      },
      place_id: 'ChIJgQYekPiipBIRr6fNOMV-5bc',
    },
    'Camp Nou': {
      adr_address: '<span class="street-address">C/ d&#39;Arístides Maillol, 12</span>, <span class="region">Les Corts</span>, <span class="postal-code">08028</span> <span class="locality">Barcelona</span>, <span class="country-name">España</span>',
      formatted_address: "C/ d'Arístides Maillol, 12, Les Corts, 08028 Barcelona, España",
      geometry: {
        location: {
          lat: 41.380896,
          lng: 2.1228198,
        },
      },
      place_id: 'ChIJr3spdvWYpBIRuQQb_jBT9kQ',
    },
    'El Born': {
      adr_address: 'El Born, <span class="region">Ciutat Vella</span>, <span class="postal-code">08003</span> <span class="locality">Barcelona</span>, <span class="country-name">España</span>',
      formatted_address: 'El Born, Ciutat Vella, 08003 Barcelona, España',
      geometry: {
        location: {
          lat: 41.3842722,
          lng: 2.1824478,
        },
      },
      place_id: 'ChIJW14XZ_6ipBIRuOyAZ6zi40U',
    },
    'Estación de Autobuses Barcelona Nord': {
      adr_address: '<span class="street-address">C. de Nàpols, 68</span>, <span class="region">L&#39;Eixample</span>, <span class="postal-code">08013</span> <span class="locality">Barcelona</span>, <span class="country-name">España</span>',
      formatted_address: "C. de Nàpols, 68, L'Eixample, 08013 Barcelona, España",
      geometry: {
        location: {
          lat: 41.3938547,
          lng: 2.1818339,
        },
      },
      place_id: 'ChIJFVQAteOipBIRBPOf1krlRV0',
    },
    'La Rambla': {
      adr_address: '<span class="street-address">La Rambla</span>, <span class="locality">Barcelona</span>, <span class="country-name">España</span>',
      formatted_address: 'La Rambla, Barcelona, España',
      geometry: {
        location: {
          lat: 41.3856087,
          lng: 2.1698166,
        },
      },
      place_id: 'EhtMYSBSYW1ibGEsIEJhcmNlbG9uYSwgU3BhaW4iLiosChQKEgnJFBcIWKKkEhHEvUKIrPe-JBIUChIJ5TCOcRaYpBIRCmZHTz37sEQ',
    },
    Montjuïc: {
      adr_address: 'Montjuic, <span class="region">Distrito de Sants-Montjuïc</span>, <span class="postal-code">08038</span> <span class="locality">Barcelona</span>, <span class="country-name">España</span>',
      formatted_address: 'Montjuic, Distrito de Sants-Montjuïc, 08038 Barcelona, España',
      geometry: {
        location: {
          lat: 41.3640002,
          lng: 2.1674931,
        },
      },
      place_id: 'ChIJva7iMEKipBIRUEv5vj7GFgE',
    },
    'Parque Güell': {
      adr_address: '<span class="region">Gracia</span>, <span class="postal-code">08024</span> <span class="locality">Barcelona</span>, <span class="region">Provincia de Barcelona</span>, <span class="country-name">España</span>',
      formatted_address: 'Gracia, 08024 Barcelona, Provincia de Barcelona, España',
      geometry: {
        location: {
          lat: 41.41449480000001,
          lng: 2.1526945,
        },
      },
      place_id: 'ChIJq0HUUq6ipBIRWM6qGqALmok',
    },
    'Sagrada Familia': {
      adr_address: 'Sagrada Familia, <span class="region">Eixample</span>, <span class="locality">Barcelona</span>, <span class="country-name">España</span>',
      formatted_address: 'Sagrada Familia, Eixample, Barcelona, España',
      geometry: {
        location: {
          lat: 41.4043239,
          lng: 2.1746666,
        },
      },
      place_id: 'ChIJmyCPhtuipBIRHIgYpfufcN0',
    },
  },
  madrid: {
    'Aeropuerto Adolfo Suárez Madrid-Barajas': {
      adr_address: '<span class="street-address">Aeropuerto de Madrid</span>, <span class="region">Barajas</span>, <span class="postal-code">28042</span> <span class="locality">Madrid</span>, <span class="country-name">España</span>',
      formatted_address: 'Aeropuerto de Madrid, Barajas, 28042 Madrid, España',
      geometry: {
        location: {
          lat: 40.4683106,
          lng: -3.5709933,
        },
      },
      place_id: 'ChIJ4dxcXzQxQg0RUsIAIb-mNLw',
    },
    'Barrio La Latina': {
      adr_address: 'Barrio de La Latina, <span class="region">Centro</span>, <span class="postal-code">28005</span> <span class="locality">Madrid</span>, <span class="country-name">España</span>',
      formatted_address: 'Barrio de La Latina, Centro, 28005 Madrid, España',
      geometry: {
        location: {
          lat: 40.4115369,
          lng: -3.7106186,
        },
      },
      place_id: 'ChIJc8SAjdcnQg0RXViU5YCmRWQ',
    },
    Lavapiés: {
      adr_address: 'Lavapiés, <span class="region">Centro</span>, <span class="postal-code">28012</span> <span class="locality">Madrid</span>, <span class="country-name">España</span>',
      formatted_address: 'Lavapiés, Centro, 28012 Madrid, España',
      geometry: {
        location: {
          lat: 40.4084422,
          lng: -3.7007926,
        },
      },
      place_id: 'ChIJxfUOYysmQg0R0IXw9eirnnE',
    },
    'Malasaña / Universidad': {
      adr_address: 'Universidad, <span class="region">Centro</span>, <span class="locality">Madrid</span>, <span class="country-name">España</span>',
      formatted_address: 'Universidad, Centro, Madrid, España',
      geometry: {
        location: {
          lat: 40.4233716,
          lng: -3.7077922,
        },
      },
      place_id: 'ChIJ8ek8h2QoQg0RTBJi44fo6qA',
    },
    'Mercado de San Miguel': {
      adr_address: 'Mercado de San Miguel, <span class="region">Centro</span>, <span class="postal-code">28005</span> <span class="locality">Madrid</span>, <span class="country-name">España</span>',
      formatted_address: 'Mercado de San Miguel, Centro, 28005 Madrid, España',
      geometry: {
        location: {
          lat: 40.4153716,
          lng: -3.708997,
        },
      },
      place_id: 'ChIJq4LgIHkoQg0RawOFA_7qAVw',
    },
    'Palacio de Cibeles': {
      adr_address: '<span class="street-address">Plaza Cibeles, 1A</span>, <span class="region">Retiro</span>, <span class="postal-code">28014</span> <span class="locality">Madrid</span>, <span class="country-name">España</span>',
      formatted_address: 'Plaza Cibeles, 1A, Retiro, 28014 Madrid, España',
      geometry: {
        location: {
          lat: 40.4188537,
          lng: -3.6919631,
        },
      },
      place_id: 'ChIJY4IWkCIpQg0RXPVabPwKo3M',
    },
    'Palacio Real de Madrid': {
      adr_address: '<span class="street-address">C. de Bailén, s/n</span>, <span class="region">Centro</span>, <span class="postal-code">28071</span> <span class="locality">Madrid</span>, <span class="country-name">España</span>',
      formatted_address: 'C. de Bailén, s/n, Centro, 28071 Madrid, España',
      geometry: {
        location: {
          lat: 40.417955,
          lng: -3.714311999999999,
        },
      },
      place_id: 'ChIJwamkfX4oQg0RUUjO1nnsfy4',
    },
    'Plaza Mayor': {
      adr_address: '<span class="street-address">Pl. Mayor</span>, <span class="region">Centro</span>, <span class="postal-code">28012</span> <span class="locality">Madrid</span>, <span class="country-name">España</span>',
      business_status: 'OPERATIONAL',
      formatted_address: 'Pl. Mayor, Centro, 28012 Madrid, España',
      geometry: {
        location: {
          lat: 40.415511,
          lng: -3.707400899999999,
        },
      },
      place_id: 'ChIJZX56134oQg0RHBgRAVQ8pkk',
    },
    'Puerta de Alcalá': {
      adr_address: '<span class="street-address">Pl. de la Independencia, s/n</span>, <span class="region">Retiro</span>, <span class="postal-code">28001</span> <span class="locality">Madrid</span>, <span class="country-name">España</span>',
      formatted_address: 'Pl. de la Independencia, s/n, Retiro, 28001 Madrid, España',
      geometry: {
        location: {
          lat: 40.419992,
          lng: -3.688737,
        },
      },
      place_id: 'ChIJJ1KGSpooQg0R8YZKFDqLJ5g',
    },
    'Puerta del Sol': {
      adr_address: 'Puerta del Sol, <span class="region">Centro</span>, <span class="locality">Madrid</span>, <span class="country-name">España</span>',
      formatted_address: 'Puerta del Sol, Centro, Madrid, España',
      geometry: {
        location: {
          lat: 40.4169473,
          lng: -3.7035285,
        },
      },
      place_id: 'ChIJx319oIAoQg0RecYd2lfuSmk',
    },
    Retiro: {
      adr_address: '<span class="region">Retiro</span>, <span class="locality">Madrid</span>, <span class="country-name">España</span>',
      formatted_address: 'Retiro, Madrid, España',
      geometry: {
        location: {
          lat: 40.4113349,
          lng: -3.6749081,
        },
      },
      place_id: 'ChIJpekqRqAoQg0RdtyjNRaxELg',
    },

  },
  malaga: {
    'Aeropuerto Costa del Sol (AGP)': {
      formatted_address: 'Aeropuerto Costa del Sol (AGP), Málaga',
      geometry: {
        location: {
          lat: 36.6767427,
          lng: -4.4938696,
        },
      },
    },
    'Estación María Zambrano': {
      formatted_address: 'Estación María Zambrano, Málaga',
      geometry: {
        location: {
          lat: 36.71191930000001,
          lng: -4.4319624,
        },
      },
    },
    'Museo Picasso': {
      formatted_address: 'Museo Picasso, Palacio de Buenavista, Málaga',
      geometry: {
        location: {
          lat: 36.7217363,
          lng: -4.4184291,
        },
      },
    },
    'Catedral de la Encarnación de Málaga': {
      formatted_address: 'Catedral de la Encarnación de Málaga',
      geometry: {
        location: {
          lat: 36.7201678,
          lng: -4.419310600000001,
        },
      },
    },
    'Castillo de Gibralfaro': {
      formatted_address: 'Castillo de Gibralfaro Málaga',
      geometry: {
        location: {
          lat: 36.7235379,
          lng: -4.410563,
        },
      },
    },
    'Teatro Romano de Málaga': {
      formatted_address: 'Teatro Romano de Málaga',
      geometry: {
        location: {
          lat: 36.7211729,
          lng: -4.416823,
        },
      },
    },
    'Playa de la Malagueta': {
      formatted_address: 'Playa de la Malagueta, Málaga, España',
      geometry: {
        location: {
          lat: 36.71705099999999,
          lng: -4.410283499999999,
        },
      },
    },
    'Plaza de la Merced': {
      formatted_address: 'Plaza de la Merced de Málaga',
      geometry: {
        location: {
          lat: 36.72361900000001,
          lng: -4.4172399,
        },
      },
    },
    'Puerto de Málaga y Muelle Uno': {
      formatted_address: 'Puerto de Málaga, Muelle Uno',
      geometry: {
        location: {
          lat: 36.7157744,
          lng: -4.4192431,
        },
      },
    },
    'Centro Histórico Málaga': {
      formatted_address: 'Centro Histórico, Distrito Centro, Málaga, España',
      geometry: {
        location: {
          lat: 36.7202454,
          lng: -4.422067300000001,
        },
      },
    },
  },
  sevilla: {
    'Aeropuerto de Sevilla-San Pablo': {
      formatted_address: 'Aeropuerto de Sevilla-San Pablo',
      geometry: {
        location: {
          lat: 37.4202658,
          lng: -5.8907912,
        },
      },
    },
    'Estación de tren Sevilla-Santa Justa': {
      formatted_address: 'Sevilla Sta. Justa',
      geometry: {
        location: {
          lat: 37.39238479999999,
          lng: -5.974937700000001,
        },
      },
    },
    'Plaza de España': {
      formatted_address: 'Plaza de España, Sevilla, España',
      geometry: {
        location: {
          lat: 37.377021,
          lng: -5.9870583,
        },
      },
    },
    'Barrio Santa Cruz': {
      formatted_address: 'Barrio Santa Cruz, Sevilla',
      geometry: {
        location: {
          lat: 37.3842288,
          lng: -5.9903422,
        },
      },
    },
    'Barrio Triana': {
      formatted_address: 'Barrio Triana, Sevilla',
      geometry: {
        location: {
          lat: 37.3810861,
          lng: -6.0093952,
        },
      },
    },
    'Real Alcázar de Sevilla': {
      formatted_address: 'Real Alcázar de Sevilla, Casco Antiguo',
      geometry: {
        location: {
          lat: 37.3830519,
          lng: -5.9902257,
        },
      },
    },
    'Catedral de Sevilla y la Giralda': {
      formatted_address: 'Catedral de Sevilla y la Giralda',
      geometry: {
        location: {
          lat: 37.3861784,
          lng: -5.992613700000001,
        },
      },
    },
    'Setas de Sevilla (Metropol Parasol)': {
      formatted_address: 'Setas de Sevilla (Metropol Parasol)',
      geometry: {
        location: {
          lat: 37.39327009999999,
          lng: -5.9917478,
        },
      },
    },
    'Torre del Oro': {
      formatted_address: 'Torre del Oro, Casco Antiguo Sevilla',
      geometry: {
        location: {
          lat: 37.3824529,
          lng: -5.9963128,
        },
      },
    },
    'Plaza de Toros': {
      formatted_address: 'Plaza de Toros de Sevilla',
      geometry: {
        location: {
          lat: 37.3855924,
          lng: -5.9988272,
        },
      },
    },
  },
  valencia: {
    'Aeropuerto Internacional de Valencia-Manises': {
      formatted_address: 'Aeropuerto Internacional de Valencia-Manises',
      geometry: {
        location: {
          lat: 39.4883525,
          lng: -0.484433,
        },
      },
    },
    'Estación del Norte / Estació del Nord': {
      formatted_address: 'Estación del Norte, Valencia',
      geometry: {
        location: {
          lat: 39.4660303,
          lng: -0.3774450999999999,
        },
      },
    },
    'Ciudad de las Artes y las Ciencias': {
      formatted_address: 'Ciudad de las Artes y las Ciencias, Valencia',
      geometry: {
        location: {
          lat: 39.4548751,
          lng: -0.3504904,
        },
      },
    },
    'Catedral de Valencia': {
      formatted_address: 'Catedral de Valencia',
      geometry: {
        location: {
          lat: 39.47528579999999,
          lng: -0.3754667,
        },
      },
    },
    'Mercado Central de Valencia': {
      formatted_address: 'Mercado Central de Valencia',
      geometry: {
        location: {
          lat: 39.4734632,
          lng: -0.3790343,
        },
      },
    },
    'Barrio del Carmen': {
      formatted_address: 'Catedral de Valencia',
      geometry: {
        location: {
          lat: 39.4793514,
          lng: -0.380721,
        },
      },
    },
    'La Lonja de la Seda': {
      formatted_address: 'La Lonja de la Seda, Valencia',
      geometry: {
        location: {
          lat: 39.4743857,
          lng: -0.3783299000000001,
        },
      },
    },
    'Playa de la Malvarrosa': {
      formatted_address: 'Playa de la Malvarrosa, Valencia',
      geometry: {
        location: {
          lat: 39.47726,
          lng: -0.3233746,
        },
      },
    },
    Oceanogràfic: {
      formatted_address: 'Oceanogràfic, Valencia',
      geometry: {
        location: {
          lat: 39.4527203,
          lng: -0.3480668999999999,
        },
      },
    },
    'Bioparc Valencia': {
      formatted_address: 'Bioparc Valencia',
      geometry: {
        location: {
          lat: 39.4780257,
          lng: -0.4076105999999999,
        },
      },
    },
  },

  //  ITALIA
  roma: {
    'Aeroporto di Ciampino': {
      adr_address: '<span class="street-address">Via Appia Nuova, 1651</span>, <span class="postal-code">00040</span> <span class="locality">Ciampino</span> <span class="region">RM</span>, <span class="country-name">Italia</span>',
      formatted_address: 'Via Appia Nuova, 1651, 00040 Ciampino RM, Italia',
      geometry: {
        location: {
          lat: 41.7992296,
          lng: 12.5931741,
        },
      },
      place_id: 'ChIJA-mdOLaIJRMRDVHFjx0Gtu0',
    },
    'Aeroporto Internazionale Leonardo da Vinci (Fiumicino)': {
      adr_address: '<span class="street-address">Via L.Da Vinci</span>, <span class="postal-code">00015</span> <span class="locality">Roma</span> <span class="region">RM</span>, <span class="country-name">Italia</span>',
      formatted_address: 'Via L.Da Vinci, 00015 Roma RM, Italia',
      geometry: {
        location: {
          lat: 41.8058476,
          lng: 12.2583386,
        },
      },
      place_id: 'ChIJHxSYOHnwJRMRbzFY47QT5a8',
    },
    'Castel Sant\'Angelo': {
      adr_address: '<span class="street-address">Lungotevere Castello, 50</span>, <span class="postal-code">00193</span> <span class="locality">Roma</span> <span class="region">RM</span>, <span class="country-name">Italia</span>',
      formatted_address: 'Lungotevere Castello, 50, 00193 Roma RM, Italia',
      geometry: {
        location: {
          lat: 41.90306319999999,
          lng: 12.466276,
        },
      },
      place_id: 'ChIJ0aTnEYeKJRMRiUF95xwRbDY',
    },
    'Città del Vaticano e Basilica di San Pietro': {
      adr_address: '<span class="street-address">Piazza San Pietro</span>, <span class="postal-code">00120</span> <span class="locality">Città del Vaticano</span>',
      formatted_address: 'Piazza San Pietro, 00120 Città del Vaticano',
      geometry: {
        location: {
          lat: 41.90216669999999,
          lng: 12.4539367,
        },
      },
      place_id: 'ChIJWZsUt2FgLxMRg1KHzXfwS3I',
    },
    Colosseo: {
      adr_address: '<span class="street-address">Piazza del Colosseo, 1</span>, <span class="postal-code">00184</span> <span class="locality">Roma</span> <span class="region">RM</span>, <span class="country-name">Italia</span>',
      formatted_address: 'Piazza del Colosseo, 1, 00184 Roma RM, Italia',
      geometry: {
        location: {
          lat: 41.8902102,
          lng: 12.4922309,
        },
      },
      place_id: 'ChIJrRMgU7ZhLxMRxAOFkC7I8Sg',
    },
    'Fontana di Trevi': {
      adr_address: '<span class="street-address">Piazza di Trevi</span>, <span class="postal-code">00187</span> <span class="locality">Roma</span> <span class="region">RM</span>, <span class="country-name">Italia</span>',
      formatted_address: 'Piazza di Trevi, 00187 Roma RM, Italia',
      geometry: {
        location: {
          lat: 41.9009325,
          lng: 12.483313,
        },
      },
      place_id: 'ChIJ1UCDJ1NgLxMRtrsCzOHxdvY',
    },
    'Parque Borghese': {
      adr_address: '<span class="postal-code">00197</span> <span class="locality">Roma</span> <span class="region">RM</span>, <span class="country-name">Italia</span>',
      formatted_address: '00197 Roma RM, Italia',
      geometry: {
        location: {
          lat: 41.9128873,
          lng: 12.4852085,
        },
      },
      place_id: 'ChIJj1M8HQJhLxMRRI6D_z18Pes',
    },
    Pantheon: {
      adr_address: '<span class="street-address">Piazza della Rotonda</span>, <span class="postal-code">00186</span> <span class="locality">Roma</span> <span class="region">RM</span>, <span class="country-name">Italia</span>',
      formatted_address: 'Piazza della Rotonda, 00186 Roma RM, Italia',
      geometry: {
        location: {
          lat: 41.8986108,
          lng: 12.4768729,
        },
      },
      place_id: 'ChIJqUCGZ09gLxMRLM42IPpl0co',
    },
    'Piazza Navona': {
      adr_address: '<span class="street-address">Piazza Navona</span>, <span class="postal-code">00186</span> <span class="locality">Roma</span> <span class="region">RM</span>, <span class="country-name">Italia</span>',
      formatted_address: 'Piazza Navona, 00186 Roma RM, Italia',
      geometry: {
        location: {
          lat: 41.8991633,
          lng: 12.4730742,
        },
      },
      place_id: 'ChIJPRydwYNgLxMRSjOCLlYkV6M',
    },
    Trastevere: {
      adr_address: 'Trastevere, <span class="locality">Roma</span> <span class="region">RM</span>, <span class="country-name">Italia</span>',
      formatted_address: 'Trastevere, Roma RM, Italia',
      geometry: {
        location: {
          lat: 41.8848294,
          lng: 12.4704017,
        },
      },
      place_id: 'ChIJ921caWhgLxMRM_bfeCcgn6M',
    },
    'Stazione Termini': {
      adr_address: '<span class="street-address">Via Giovanni Giolitti, 2</span>, <span class="postal-code">00185</span> <span class="locality">Roma</span> <span class="region">RM</span>, <span class="country-name">Italia</span>',
      formatted_address: 'Via Giovanni Giolitti, 2, 00185 Roma RM, Italia',
      geometry: {
        location: {
          lat: 41.9012792,
          lng: 12.5022033,
        },
      },
      place_id: 'ChIJ64Qs5aNhLxMRhQHuYEHHciA',
    },
  },
  napoles: {
    'Aeropuerto de Nápoles - Capodichino': {
      formatted_address: 'Aeropuerto de Napoli - Capodichino',
      geometry: {
        location: {
          lat: 40.8846816,
          lng: 14.2891552,
        },
      },
    },
    'Estación de Tren Napoli Centrale': {
      formatted_address: 'Estación de Tren Napoli Centrale',
      geometry: {
        location: {
          lat: 40.85292219999999,
          lng: 14.2723487,
        },
      },
    },
    'Capilla Sansevero': {
      formatted_address: 'Capilla Sansevero Napoli',
      geometry: {
        location: {
          lat: 40.8492951,
          lng: 14.2548837,
        },
      },
    },
    'Palacio Real/Palazzo Reale': {
      formatted_address: 'Palazzo Reale di Napoli',
      geometry: {
        location: {
          lat: 40.8362316,
          lng: 14.2494027,
        },
      },
    },
    'Centro Histórico Napoli': {
      formatted_address: 'Centro Histórico Napoli',
      geometry: {
        location: {
          lat: 40.8516638,
          lng: 14.2594066,
        },
      },
    },
    'Monte Vesubio': {
      formatted_address: 'Monte Vesubio',
      geometry: {
        location: {
          lat: 40.82238299999999,
          lng: 14.4289058,
        },
      },
    },
    'Castillo del Huevo/Castel dell\'Ovo': {
      formatted_address: 'Castel dell\'Ovo',
      geometry: {
        location: {
          lat: 40.8283157,
          lng: 14.2476044,
        },
      },
    },
    'Catacumbas de San Gennaro': {
      formatted_address: 'Catacumbas de San Gennaro',
      geometry: {
        location: {
          lat: 40.8650615,
          lng: 14.2474297,
        },
      },
    },
  },
  firenze: {
    'Aeroporto di Firenze': {
      formatted_address: 'Via del Termine, 11, 50127 Firenze FI, Italia',
      geometry: {
        location: {
          lat: 43.8094619,
          lng: 11.2027587,
        },
      },
    },
    'Stazione di Firenze Santa Maria Novella': {
      formatted_address: 'Piazza della Stazione, 50123 Firenze FI, Italia',
      geometry: {
        location: {
          lat: 43.77667149999999,
          lng: 11.2479159,
        },
      },
    },
    'Cattedrale di Santa Maria del Fiore': {
      formatted_address: 'Piazza del Duomo, 50122 Firenze FI, Italia',
      geometry: {
        location: {
          lat: 43.77314499999999,
          lng: 11.2559602,
        },
      },
    },
    'Galleria degli Uffizi': {
      formatted_address: 'Piazzale degli Uffizi, 6, 50122 Firenze FI, Italia',
      geometry: {
        location: {
          lat: 43.7677856,
          lng: 11.2553108,
        },
      },
    },
    'Galleria dell\'Accademia': {
      formatted_address: 'Via Ricasoli, 58/60, 50129 Firenze FI, Italia',
      geometry: {
        location: {
          lat: 43.77681450000001,
          lng: 11.2586424,
        },
      },
    },
    'Ponte Vecchio': {
      formatted_address: 'Ponte Vecchio, 50125 Firenze FI, Italia',
      geometry: {
        location: {
          lat: 43.76792500000001,
          lng: 11.2531435,
        },
      },
    },
    'Palazzo Vecchio': {
      formatted_address: 'P.za della Signoria, 50122 Firenze FI, Italia',
      geometry: {
        location: {
          lat: 43.7693012,
          lng: 11.2561509,
        },
      },
    },
    'Piazza della Repubblica': {
      formatted_address: 'Piazza della Repubblica, 50123 Firenze FI, Italia',
      geometry: {
        location: {
          lat: 43.7715112,
          lng: 11.2539314,
        },
      },
    },
    'Giardino di Boboli': {
      formatted_address: '50125 Florencia, Italia',
      geometry: {
        location: {
          lat: 43.76249719999999,
          lng: 11.2483996,
        },
      },
    },
    Oltrarno: {
      formatted_address: 'Oltrarno, 50125 Florencia, Italia',
      geometry: {
        location: {
          lat: 43.7651277,
          lng: 11.250063,
        },
      },
    },
  },
  milano: {
    'Aeroporto di Milano-Malpensa (MXP)': {
      formatted_address: '21010 Ferno, Varese, Italia',
      geometry: {
        location: {
          lat: 45.62847720000001,
          lng: 8.725991100000002,
        },
      },
    },
    'Aeroporto di Milano-Linate (LIN)': {
      formatted_address: 'Viale Enrico Forlanini, 20054 Segrate MI, Italia',
      geometry: {
        location: {
          lat: 45.4533403,
          lng: 9.2762859,
        },
      },
    },
    'Stazione Centrale di Milano': {
      formatted_address: "Piazza Duca d'Aosta, 1, 20124 Milano MI, Italia",
      geometry: {
        location: {
          lat: 45.487137,
          lng: 9.204822000000002,
        },
      },
    },
    'Stazione di Milano Porta Garibaldi': {
      formatted_address: 'Stazione, P.za Sigmund Freud, 1, 20124 Milano MI, Italia',
      geometry: {
        location: {
          lat: 45.4844919,
          lng: 9.1873774,
        },
      },
    },
    'Duomo di Milano': {
      formatted_address: 'P.za del Duomo, 20122 Milano MI, Italia',
      geometry: {
        location: {
          lat: 45.4640976,
          lng: 9.1919265,
        },
      },
    },
    'Galleria Vittorio Emanuele II': {
      formatted_address: '20123 Milán, Italia',
      geometry: {
        location: {
          lat: 45.4658434,
          lng: 9.1899401,
        },
      },
    },
    'Teatro alla Scala': {
      formatted_address: 'V. Filodrammatici, 2, 20121 Milano MI, Italia',
      geometry: {
        location: {
          lat: 45.4674021,
          lng: 9.189551200000002,
        },
      },
    },
    'Castello Sforzesco': {
      formatted_address: 'Piazza Castello, 20121 Milano MI, Italia',
      geometry: {
        location: {
          lat: 45.4704762,
          lng: 9.1793325,
        },
      },
    },
    'Santa Maria delle Grazie': {
      formatted_address: 'Piazza di Santa Maria delle Grazie, 20123 Milano MI, Italia',
      geometry: {
        location: {
          lat: 45.465963,
          lng: 9.170962099999999,
        },
      },
    },
    Navigli: {
      formatted_address: 'Navigli, Milano MI, Italia',
      geometry: {
        location: {
          lat: 45.4477479,
          lng: 9.1696288,
        },
      },
    },
  },

  //  REINO UNIDO
  london: {
    'Big Ben': {
      formatted_address: 'Big Ben',
      geometry: {
        location: {
          lat: 51.50072919999999,
          lng: -0.1246254,
        },
      },
    },
    'Buckingham Palace': {
      formatted_address: 'Buckingham Palace',
      geometry: {
        location: {
          lat: 51.501364,
          lng: -0.14189,
        },
      },
    },
    'London City Airport (LCY)': {
      formatted_address: 'London City Airport (LCY)',
      geometry: {
        location: {
          lat: 51.5048437,
          lng: 0.04951800000000001,
        },
      },
    },
    'Heathrow Airport (LHR)': {
      formatted_address: 'Heathrow Airport (LHR)',
      geometry: {
        location: {
          lat: 51.4679914,
          lng: -0.455051,
        },
      },
    },
    'London Eye': {
      formatted_address: 'London Eye',
      geometry: {
        location: {
          lat: 51.5031864,
          lng: -0.1195192,
        },
      },
    },
    'Tower of London': {
      formatted_address: 'Tower of London',
      geometry: {
        location: {
          lat: 51.50811239999999,
          lng: -0.0759493,
        },
      },
    },
    'Paddington Station': {
      formatted_address: 'Paddington Station',
      geometry: {
        location: {
          lat: 51.5154108,
          lng: -0.1754019,
        },
      },
    },
    'King\'s Cross Station': {
      formatted_address: 'King\'s Cross Station',
      geometry: {
        location: {
          lat: 51.5306865,
          lng: -0.1233551,
        },
      },
    },
    'Waterloo Station': {
      formatted_address: 'Waterloo Station',
      geometry: {
        location: {
          lat: 51.50312169999999,
          lng: -0.1129493,
        },
      },
    },
  },

  //  ESTADOS UNIDOS
  miami: {
    'Miami International Airport (MIA)': {
      formatted_address: 'Miami International Airport, Miami, FL, USA',
      geometry: {
        location: {
          lat: 25.795865,
          lng: -80.287046,
        },
      },
    },

    PortMiami: {
      formatted_address: 'PortMiami, Miami, FL, USA',
      geometry: {
        location: {
          lat: 25.778135,
          lng: -80.179100,
        },
      },
    },

    'Miami Beach': {
      formatted_address: 'Miami Beach, FL, USA',
      geometry: {
        location: {
          lat: 25.790654,
          lng: -80.130045,
        },
      },
    },

    'South Beach': {
      formatted_address: 'South Beach, Miami Beach, FL, USA',
      geometry: {
        location: {
          lat: 25.782545,
          lng: -80.134042,
        },
      },
    },

    'Ocean Drive': {
      formatted_address: 'Ocean Drive, Miami Beach, FL, USA',
      geometry: {
        location: {
          lat: 25.780673,
          lng: -80.130045,
        },
      },
    },

    'Art Deco Historic District': {
      formatted_address: 'Art Deco Historic District, Miami Beach, FL, USA',
      geometry: {
        location: {
          lat: 25.786433,
          lng: -80.131014,
        },
      },
    },

    'Wynwood Arts District': {
      formatted_address: 'Wynwood, Miami, FL, USA',
      geometry: {
        location: {
          lat: 25.800308,
          lng: -80.199539,
        },
      },
    },

    'Little Havana (Calle Ocho)': {
      formatted_address: 'Little Havana, Miami, FL, USA',
      geometry: {
        location: {
          lat: 25.765053,
          lng: -80.219561,
        },
      },
    },

    'Bayside Marketplace': {
      formatted_address: 'Bayside Marketplace, Miami, FL, USA',
      geometry: {
        location: {
          lat: 25.778408,
          lng: -80.186035,
        },
      },
    },

    'Downtown Miami': {
      formatted_address: 'Downtown Miami, Miami, FL, USA',
      geometry: {
        location: {
          lat: 25.774266,
          lng: -80.193659,
        },
      },
    },
  },
  'Fort Lauderdale-Hollywood International Airport (FLL)': {
    formatted_address: 'Fort Lauderdale-Hollywood International Airport, FL, USA',
    geometry: {
      location: {
        lat: 26.072583,
        lng: -80.152749,
      },
    },
  },

  'Port Everglades (Fort Lauderdale)': {
    formatted_address: 'Port Everglades, Fort Lauderdale, FL, USA',
    geometry: {
      location: {
        lat: 26.090523,
        lng: -80.121069,
      },
    },
  },
};

export default neighborhoods;

/* Para guardar el place: hacer una búsqueda en esa ubicación y
    copiar el valor place del Session Storage.
    Eliminar del objeto lo que no sirve
*/
